/* SES Palma · página de pedidos wholesale (se edita directamente; el antiguo build.py ya no existe).
   Núcleo compartido con el portal: assets/ses-b2b-core.js (window.SESB2B). */
'use strict';
const APP_ROOT = document.getElementById('ses-app') || document.body;
const byId = (id) => APP_ROOT.querySelector('#' + id);
const qs  = (sel) => APP_ROOT.querySelector(sel);
const qsa = (sel) => APP_ROOT.querySelectorAll(sel);

const B2B = window.SESB2B || null;
// Interruptores de la sección (ses-pedidos.liquid). Sin la sección (pruebas) todo encendido.
const FLAGS = window.SES_FLAGS || { topbar: true, pricesBrowse: true, showRrp: true, cardSwatches: true, photoStates: true, sheetPhotoBig: true, sizeCurves: true, heroI18n: true, cookieOffset: true, gateBlur: false, excel: true };
const F = (k) => !!FLAGS[k];
const CFG = window.SES_B2B_CONFIG || {};
const PORTAL_URL = CFG.portalUrl || '/pages/b2b-cuenta';

// Cesta en este navegador, por usuario + empresa + temporada (dos cuentas en el mismo equipo no se mezclan).
// El portal («Repetir pedido») escribe en la misma clave: ver basketKey en ses-b2b-portal.js.
const STORE_KEY = 'ses_order_draft_v1';
const CURVE_KEY = 'ses_curve_v2';
const HANDOFF_KEY = 'ses_b2b_handoff';
const IDEM_KEY = 'ses_b2b_idem';

const state = {
  config: null,
  catalog: [],
  terms: null,            // CGV (terms/cgv-ss27.json)
  termsHash: null,        // SHA-256 del texto íntegro aceptado
  termsAccepted: null,    // { at, version, hash, privacyAt } una vez el comprador acepta
  buyer: {},
  // qty[sku] = number
  qty: {},
  // sku -> { styleCode, styleName, type, color, size }
  skuMeta: {},
  filterGroup: 'all',
  search: '',
  lang: 'es',
  // dataURL del logo (marca laurel) para el PDF — igual que el CRM
  logoDataUrl: null,
  // cache url -> dataURL para incrustar fotos de producto en el PDF
  imgCache: {},
  // color elegido en cada tarjeta (código de estilo -> índice de color)
  cardColor: {},
  // curvas editadas por familia de tallas (firma "M,L,XL,XXL" -> {talla: uds})
  curveOverrides: {},
  // sesión del portal: empresa, tiendas, precios propios y PVP por país (solo en memoria)
  auth: {
    session: null, me: null, loading: false, error: null,
    companyId: null, company: null, storeIds: [],
    prices: new Map(), rrp: new Map(), pricesLoaded: false, priceError: null,
    draftRequestId: null, po: '', comment: '', rules: null,
  },
};

/* ---------- estructura hoja de pedido (idéntica al CRM) ---------- */
// Columnas de talla canónicas del CRM (proforma_pdf_service.SIZE_COLUMNS)
const SIZE_COLS = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'S/M', 'M/L', 'U'];
// Paleta exacta de los PDF del CRM (pdf_styles.py)
const DOC = {
  cream: '#f4f4ed',     // SES_CREAM — tarjeta FACTURAR A / ENVIAR A
  tableBg: '#f9f7f4',   // TABLE_BG — barra de términos
  goldWash: '#fcf1d5',  // SES_GOLD_WASH — columna TOTAL
  creamSoft: '#faf8f2', // SES_CREAM_SOFT — celdas de talla vacías
  rule: '#d4d4d4',      // RULE_COLOR — líneas
  ink: '#1a1a1a',       // TEXT_BLACK
  taupe: '#aa8a70',     // SES_TAUPE — etiquetas / composición
  grey: '#919da9',      // SES_GREY — nombre / color / fecha
};

/* ---------- i18n (ES / EN / FR / IT) ---------- */
const LANGS = ['es', 'en', 'fr', 'it'];
const LANG_KEY = 'ses_lang_v1';
const I18N = {
  buyer_title:   { es: 'Datos del comprador', en: 'Buyer details', fr: "Coordonnées de l'acheteur", it: "Dati dell'acquirente" },
  catalog:       { es: 'Catálogo', en: 'Catalogue', fr: 'Catalogue', it: 'Catalogo' },
  search_ph:     { es: 'Buscar estilo o color…', en: 'Search style or colour…', fr: 'Rechercher un style ou une couleur…', it: 'Cerca stile o colore…' },
  empty:         { es: 'No hay resultados para tu búsqueda.', en: 'No results for your search.', fr: 'Aucun résultat pour votre recherche.', it: 'Nessun risultato per la tua ricerca.' },
  unit_one:      { es: 'ud', en: 'unit', fr: 'unité', it: 'pz' },
  line_one:      { es: '{n} línea', en: '{n} line', fr: '{n} ligne', it: '{n} riga' },
  line_many:     { es: '{n} líneas', en: '{n} lines', fr: '{n} lignes', it: '{n} righe' },
  hint_add_units:{ es: 'Añade unidades desde la ficha de cada estilo para poder enviar.', en: 'Add units from each style to be able to send.', fr: 'Ajoutez des unités depuis la fiche de chaque style pour pouvoir envoyer.', it: 'Aggiungi pezzi dalla scheda di ogni stile per poter inviare.' },
  season_ss:     { es: 'Primavera / Verano {year}', en: 'Spring / Summer {year}', fr: 'Printemps / Été {year}', it: 'Primavera / Estate {year}' },
  card_units:    { es: '{n} uds en tu pedido', en: '{n} units in your order', fr: '{n} unités dans votre commande', it: '{n} pz nel tuo ordine' },
  units:         { es: 'uds', en: 'units', fr: 'unités', it: 'pz' },
  lines:         { es: 'líneas', en: 'lines', fr: 'lignes', it: 'righe' },
  new:           { es: 'Nuevo', en: 'New', fr: 'Nouveau', it: 'Nuovo' },
  new_ready:     { es: 'Pedido nuevo listo', en: 'New order ready', fr: 'Nouvelle commande prête', it: 'Nuovo ordine pronto' },
  review:        { es: 'Ver pedido', en: 'View order', fr: 'Voir la commande', it: 'Vedi ordine' },
  review_send:   { es: 'Revisar y enviar', en: 'Review & send', fr: 'Vérifier et envoyer', it: 'Rivedi e invia' },
  send:          { es: 'Guardar y enviar', en: 'Save & send', fr: 'Enregistrer et envoyer', it: 'Salva e invia' },
  sending:       { es: 'Enviando…', en: 'Sending…', fr: 'Envoi…', it: 'Invio…' },
  review_title:  { es: 'Resumen del pedido', en: 'Order summary', fr: 'Récapitulatif de la commande', it: "Riepilogo dell'ordine" },
  close:         { es: 'Cerrar', en: 'Close', fr: 'Fermer', it: 'Chiudi' },
  pdf:           { es: 'Descargar PDF', en: 'Download PDF', fr: 'Télécharger le PDF', it: 'Scarica PDF' },
  sizes:         { es: 'Cantidades por talla', en: 'Quantities by size', fr: 'Quantités par taille', it: 'Quantità per taglia' },
  clear:         { es: 'Vaciar', en: 'Clear', fr: 'Vider', it: 'Svuota' },
  done:          { es: 'Hecho', en: 'Done', fr: 'Terminé', it: 'Fatto' },
  color_one:     { es: 'color', en: 'colour', fr: 'couleur', it: 'colore' },
  color_many:    { es: 'colores', en: 'colours', fr: 'couleurs', it: 'colori' },
  curve_title:   { es: 'Curva de tallas', en: 'Size run', fr: 'Courbe de tailles', it: 'Curva taglie' },
  curve_edit:    { es: 'Editar curva', en: 'Edit run', fr: 'Modifier', it: 'Modifica' },
  curve_order:   { es: 'Pedir curva', en: 'Order run', fr: 'Commander la courbe', it: 'Ordina curva' },
  curve_save:    { es: 'Guardar curva', en: 'Save run', fr: 'Enregistrer', it: 'Salva curva' },
  curve_hint:    { es: 'Ajusta cuántas unidades pides por talla. Se suma al pedido.', en: 'Set how many units per size. Adds to the order.', fr: "Réglez le nombre d'unités par taille. S'ajoute à la commande.", it: "Imposta le unità per taglia. Si somma all'ordine." },
  hero_scroll:   { es: 'Empezar pedido ↓', en: 'Start order ↓', fr: 'Commencer la commande ↓', it: "Inizia l'ordine ↓" },
  lookbook:      { es: 'Ver lookbook ↗', en: 'View lookbook ↗', fr: 'Voir le lookbook ↗', it: 'Vedi lookbook ↗' },
  linesheet:     { es: 'Descargar linesheet ↓', en: 'Download linesheet ↓', fr: 'Télécharger le linesheet ↓', it: 'Scarica il linesheet ↓' },
  linesheet_wip: { es: 'Preparando el linesheet con tus precios…', en: 'Preparing the linesheet with your prices…', fr: 'Préparation du linesheet avec vos prix…', it: 'Preparazione del linesheet con i tuoi prezzi…' },
  linesheet_err: { es: 'No se pudo generar el linesheet. Inténtalo de nuevo.', en: 'The linesheet could not be generated. Please try again.', fr: "Le linesheet n'a pas pu être généré. Réessayez.", it: 'Impossibile generare il linesheet. Riprova.' },
  xls_download:  { es: 'Hoja de pedido Excel ↓', en: 'Excel order form ↓', fr: 'Bon de commande Excel ↓', it: "Modulo d'ordine Excel ↓" },
  xls_upload:    { es: 'Subir Excel ↑', en: 'Upload Excel ↑', fr: 'Importer Excel ↑', it: 'Carica Excel ↑' },
  xls_wip:       { es: 'Preparando tu hoja de pedido con fotos y precios…', en: 'Preparing your order form with photos and prices…', fr: 'Préparation de votre bon de commande avec photos et prix…', it: "Preparazione del modulo d'ordine con foto e prezzi…" },
  xls_err:       { es: 'No se pudo generar el Excel. Inténtalo de nuevo.', en: 'The Excel file could not be generated. Please try again.', fr: "Le fichier Excel n'a pas pu être généré. Réessayez.", it: 'Impossibile generare il file Excel. Riprova.' },
  xls_reading:   { es: 'Leyendo el Excel…', en: 'Reading the Excel file…', fr: 'Lecture du fichier Excel…', it: 'Lettura del file Excel…' },
  xls_not_ses:   { es: 'Este archivo no es una hoja de pedido de SES Palma. Descarga la hoja desde esta página y súbela sin cambiarle las pestañas.', en: 'This file is not a SES Palma order form. Download the form from this page and upload it without changing its tabs.', fr: "Ce fichier n'est pas un bon de commande SES Palma. Téléchargez-le depuis cette page et importez-le sans modifier ses onglets.", it: "Questo file non è un modulo d'ordine SES Palma. Scaricalo da questa pagina e caricalo senza modificarne le schede." },
  xls_version:   { es: 'Esta hoja de pedido es de una versión más nueva. Recarga la página y vuelve a subirla.', en: 'This order form comes from a newer version. Reload the page and upload it again.', fr: 'Ce bon de commande provient d’une version plus récente. Rechargez la page et réessayez.', it: 'Questo modulo proviene da una versione più recente. Ricarica la pagina e riprova.' },
  xls_season:    { es: 'Esta hoja de pedido es de otra colección ({season}). Descarga la hoja actual.', en: 'This order form belongs to another collection ({season}). Download the current form.', fr: 'Ce bon de commande correspond à une autre collection ({season}). Téléchargez le bon actuel.', it: "Questo modulo è di un'altra collezione ({season}). Scarica il modulo attuale." },
  xls_empty:     { es: 'No hay cantidades en el Excel.', en: 'There are no quantities in the Excel file.', fr: "Il n'y a aucune quantité dans le fichier Excel.", it: 'Non ci sono quantità nel file Excel.' },
  xls_other_title:{ es: 'Hoja de otra cuenta', en: 'Form from another account', fr: 'Bon d’un autre compte', it: 'Modulo di un altro account' },
  xls_other_text:{ es: 'Esta hoja se preparó para {from}. ¿Cargar sus cantidades en el pedido de {to}? Se aplicarán los precios de {to}.', en: 'This form was prepared for {from}. Load its quantities into the order for {to}? Prices for {to} will apply.', fr: 'Ce bon a été préparé pour {from}. Charger ses quantités dans la commande de {to} ? Les prix de {to} s’appliqueront.', it: 'Questo modulo è stato preparato per {from}. Caricare le quantità nell’ordine di {to}? Si applicheranno i prezzi di {to}.' },
  xls_upload_title:{ es: 'Subir hoja de pedido', en: 'Upload your order form', fr: 'Importer le bon de commande', it: "Carica il modulo d'ordine" },
  xls_drop_text: { es: 'Arrastra aquí la hoja de pedido Excel que descargaste de esta página. Antes de cambiar nada verás un resumen.', en: 'Drag in the Excel order form you downloaded from this page. You will see a summary before anything changes.', fr: 'Déposez ici le bon de commande Excel téléchargé depuis cette page. Un récapitulatif s’affiche avant toute modification.', it: "Trascina qui il modulo d'ordine Excel scaricato da questa pagina. Vedrai un riepilogo prima di qualsiasi modifica." },
  xls_drop_title:{ es: 'Arrastra el archivo aquí', en: 'Drop the file here', fr: 'Déposez le fichier ici', it: 'Trascina qui il file' },
  xls_drop_hint: { es: 'o pulsa para elegirlo · .xlsx', en: 'or click to choose it · .xlsx', fr: 'ou cliquez pour le choisir · .xlsx', it: 'o fai clic per sceglierlo · .xlsx' },
  xls_drop_nofile:{ es: '¿Aún no la tienes?', en: "Don't have it yet?", fr: 'Vous ne l’avez pas encore ?', it: 'Non lo hai ancora?' },
  xls_not_xlsx:  { es: 'Elige un archivo Excel (.xlsx).', en: 'Please choose an Excel file (.xlsx).', fr: 'Choisissez un fichier Excel (.xlsx).', it: 'Scegli un file Excel (.xlsx).' },
  xls_confirm_text:{ es: '{lines} líneas · {units} unidades · {amount}.', en: '{lines} lines · {units} units · {amount}.', fr: '{lines} lignes · {units} unités · {amount}.', it: '{lines} righe · {units} unità · {amount}.' },
  xls_confirm_new:{ es: 'Se cargarán en tu pedido y se guardarán como borrador. Después podrás revisarlo y enviarlo.', en: 'They will be loaded into your order and saved as a draft. You can then review and send it.', fr: 'Elles seront chargées dans votre commande et enregistrées en brouillon. Vous pourrez ensuite la vérifier et l’envoyer.', it: "Verranno caricate nell'ordine e salvate come bozza. Poi potrai rivederlo e inviarlo." },
  xls_confirm_replace:{ es: 'Sustituyen a las cantidades que tienes ahora en el pedido y se guardarán como borrador.', en: 'They replace the quantities currently in your order and will be saved as a draft.', fr: 'Elles remplacent les quantités actuelles de votre commande et seront enregistrées en brouillon.', it: "Sostituiscono le quantità attuali dell'ordine e verranno salvate come bozza." },
  xls_confirm_ignored:{ es: 'Celdas que no se pueden cargar y se ignorarán: {n} (te las enseñamos después).', en: 'Cells that cannot be loaded and will be ignored: {n} (listed afterwards).', fr: 'Cellules non chargeables, ignorées : {n} (listées ensuite).', it: 'Celle non caricabili, ignorate: {n} (elencate dopo).' },
  xls_replace_title:{ es: 'Cargar el Excel', en: 'Load the Excel file', fr: 'Charger le fichier Excel', it: 'Carica il file Excel' },
  xls_replace_ok:{ es: 'Cargar', en: 'Load', fr: 'Charger', it: 'Carica' },
  xls_loaded:    { es: 'Excel cargado: {lines} líneas, {units} unidades.', en: 'Excel loaded: {lines} lines, {units} units.', fr: 'Excel chargé : {lines} lignes, {units} unités.', it: 'Excel caricato: {lines} righe, {units} unità.' },
  xls_loaded_saved:{ es: 'Excel cargado y guardado como borrador: {lines} líneas, {units} unidades.', en: 'Excel loaded and saved as a draft: {lines} lines, {units} units.', fr: 'Excel chargé et enregistré en brouillon : {lines} lignes, {units} unités.', it: 'Excel caricato e salvato come bozza: {lines} righe, {units} unità.' },
  xls_ignored:   { es: 'Ignorado ({n}):', en: 'Ignored ({n}):', fr: 'Ignoré ({n}) :', it: 'Ignorati ({n}):' },
  xls_bad_cell:  { es: 'Celda {ref}: no es un número entero', en: 'Cell {ref}: not a whole number', fr: 'Cellule {ref} : pas un nombre entier', it: 'Cella {ref}: non è un numero intero' },
  xls_gone:      { es: '{label}: ya no está disponible', en: '{label}: no longer available', fr: '{label} : n’est plus disponible', it: '{label}: non più disponibile' },
  billed_in:     { es: 'se factura en {cur}', en: 'invoiced in {cur}', fr: 'facturé en {cur}', it: 'fatturato in {cur}' },
  review_empty:  { es: 'Aún no has añadido cantidades.', en: "You haven't added any quantities yet.", fr: "Vous n'avez pas encore ajouté de quantités.", it: 'Non hai ancora aggiunto quantità.' },
  // filtros
  filter_all:        { es: 'Todo', en: 'All', fr: 'Tout', it: 'Tutto' },
  filter_camisas:    { es: 'Camisas', en: 'Shirts', fr: 'Chemises', it: 'Camicie' },
  filter_polos:      { es: 'Polos', en: 'Polos', fr: 'Polos', it: 'Polo' },
  filter_pantalones: { es: 'Pantalones', en: 'Trousers', fr: 'Pantalons', it: 'Pantaloni' },
  filter_chaquetas:  { es: 'Chaquetas', en: 'Jackets', fr: 'Vestes', it: 'Giacche' },
  filter_accesorios: { es: 'Accesorios', en: 'Accessories', fr: 'Accessoires', it: 'Accessori' },
  // tipos de producto
  type_Shirt:          { es: 'Camisas', en: 'Shirts', fr: 'Chemises', it: 'Camicie' },
  type_LongSleeveShirt:{ es: 'Camisa M/L', en: 'Long-sleeve shirt', fr: 'Chemise M/L', it: 'Camicia M/L' },
  type_Overshirt:      { es: 'Sobrecamisas', en: 'Overshirts', fr: 'Surchemises', it: 'Sovracamicie' },
  type_Polo:           { es: 'Polos', en: 'Polos', fr: 'Polos', it: 'Polo' },
  type_TShirt:         { es: 'Camisetas', en: 'T-shirts', fr: 'T-shirts', it: 'T-shirt' },
  type_Sweater:        { es: 'Jerséis', en: 'Knitwear', fr: 'Pulls', it: 'Maglieria' },
  type_Trousers:       { es: 'Pantalones', en: 'Trousers', fr: 'Pantalons', it: 'Pantaloni' },
  type_ShortTrousers:  { es: 'Bermudas', en: 'Shorts', fr: 'Bermudas', it: 'Bermuda' },
  type_SwimShort:      { es: 'Baño', en: 'Swimwear', fr: 'Bain', it: 'Mare' },
  type_Jacket:         { es: 'Chaquetas', en: 'Jackets', fr: 'Vestes', it: 'Giacche' },
  type_Accessory:      { es: 'Accesorios', en: 'Accessories', fr: 'Accessoires', it: 'Accessori' },
  // toasts
  t_addqty:      { es: 'Añade alguna cantidad primero', en: 'Add some quantity first', fr: "Ajoutez d'abord une quantité", it: 'Aggiungi prima una quantità' },
  // ventana de pedidos
  ow_order:      { es: 'Entrega y unidades garantizadas en pedidos hasta el', en: 'Guaranteed delivery and units for orders until', fr: "Livraison et unités garanties pour les commandes jusqu'au", it: 'Consegna e unità garantite per ordini fino al' },
  ow_delivery:   { es: 'Entregas desde el', en: 'Deliveries from', fr: 'Livraisons à partir du', it: 'Consegne dal' },
  // borradores (en la cuenta)
  draft_save:     { es: 'Guardar borrador', en: 'Save draft', fr: 'Enregistrer le brouillon', it: 'Salva bozza' },
  draft_saving:   { es: 'Guardando…', en: 'Saving…', fr: 'Enregistrement…', it: 'Salvataggio…' },
  qty_less:      { es: 'Quitar una unidad de {name} {color} talla {size}', en: 'Remove one unit of {name} {color} size {size}', fr: 'Retirer une unité de {name} {color} taille {size}', it: 'Togli un pezzo di {name} {color} taglia {size}' },
  qty_more:      { es: 'Añadir una unidad de {name} {color} talla {size}', en: 'Add one unit of {name} {color} size {size}', fr: 'Ajouter une unité de {name} {color} taille {size}', it: 'Aggiungi un pezzo di {name} {color} taglia {size}' },
  qty_units:     { es: 'Unidades de {name} {color} talla {size}', en: 'Units of {name} {color} size {size}', fr: 'Unités de {name} {color} taille {size}', it: 'Pezzi di {name} {color} taglia {size}' },
  curve_less:    { es: 'Menos en la curva, talla {size}', en: 'Fewer in the run, size {size}', fr: 'Moins dans la courbe, taille {size}', it: 'Meno nella curva, taglia {size}' },
  curve_more:    { es: 'Más en la curva, talla {size}', en: 'More in the run, size {size}', fr: 'Plus dans la courbe, taille {size}', it: 'Più nella curva, taglia {size}' },
  curve_size:    { es: 'Curva, talla {size}', en: 'Run, size {size}', fr: 'Courbe, taille {size}', it: 'Curva, taglia {size}' },
  // acceso y precios
  gate_title:    { es: 'Inicia sesión para ver precios y hacer tu pedido', en: 'Sign in to see prices and place your order', fr: 'Connectez-vous pour voir les prix et passer commande', it: 'Accedi per vedere i prezzi e fare il tuo ordine' },
  gate_text:     { es: 'El catálogo es público. Los precios mayoristas y el envío de pedidos son solo para clientes con cuenta.', en: 'The catalogue is public. Wholesale prices and ordering are for account holders only.', fr: 'Le catalogue est public. Les prix revendeurs et les commandes sont réservés aux clients ayant un compte.', it: 'Il catalogo è pubblico. Prezzi all\'ingrosso e ordini sono riservati ai clienti con account.' },
  gate_btn:      { es: 'Iniciar sesión', en: 'Sign in', fr: 'Se connecter', it: 'Accedi' },
  login_to_order:{ es: 'Inicia sesión para pedir', en: 'Sign in to order', fr: 'Connectez-vous pour commander', it: 'Accedi per ordinare' },
  login_prices:  { es: 'Inicia sesión para ver precios', en: 'Sign in to see prices', fr: 'Connectez-vous pour voir les prix', it: 'Accedi per vedere i prezzi' },
  wholesale:     { es: 'Mayorista', en: 'Wholesale', fr: 'Prix revendeur', it: 'Ingrosso' },
  wholesale_firm: { es: 'Compra en firme', en: 'Wholesale order', fr: 'Achat ferme', it: 'Acquisto a fermo' },
  per_unit:      { es: 'ud', en: 'unit', fr: 'unité', it: 'pz' },
  from_price:    { es: 'Desde {price}', en: 'From {price}', fr: 'À partir de {price}', it: 'Da {price}' },
  rrp_in:        { es: 'PVP recomendado en {country}', en: 'Recommended retail price in {country}', fr: 'Prix de vente conseillé en {country}', it: 'Prezzo al pubblico consigliato in {country}' },
  rrp_not_configured: { es: 'Sin PVP configurado', en: 'No recommended retail price configured', fr: 'Prix conseillé non configuré', it: 'Prezzo consigliato non configurato' },
  vat_incl:      { es: 'IVA incl.', en: 'incl. VAT', fr: 'TVA incl.', it: 'IVA incl.' },
  vat_excl:      { es: 'sin IVA', en: 'excl. VAT', fr: 'hors TVA', it: 'IVA escl.' },
  no_price:      { es: 'Sin precio para tu cuenta', en: 'No price for your account', fr: 'Pas de prix pour votre compte', it: 'Nessun prezzo per il tuo account' },
  prices_loading:{ es: 'Cargando tus precios…', en: 'Loading your prices…', fr: 'Chargement de vos prix…', it: 'Caricamento dei tuoi prezzi…' },
  prices_error:  { es: 'No hemos podido cargar tus precios.', en: 'We could not load your prices.', fr: 'Impossible de charger vos prix.', it: 'Non è stato possibile caricare i tuoi prezzi.' },
  prices_empty:  { es: 'Todavía no hay precios {season} para tu cuenta. Puedes preparar el pedido; te avisaremos cuando estén listos.', en: 'There are no {season} prices for your account yet. You can prepare the order; we will let you know when they are ready.', fr: 'Il n\'y a pas encore de prix {season} pour votre compte. Vous pouvez préparer la commande ; nous vous préviendrons.', it: 'Non ci sono ancora prezzi {season} per il tuo account. Puoi preparare l\'ordine; ti avviseremo quando saranno pronti.' },
  prices_updated:{ es: 'Precios actualizados el {date}', en: 'Prices updated on {date}', fr: 'Prix mis à jour le {date}', it: 'Prezzi aggiornati il {date}' },
  missing_prices:{ es: 'Estos artículos no tienen precio para tu cuenta. Quítalos o escríbenos antes de enviar:', en: 'These items have no price for your account. Remove them or contact us before sending:', fr: 'Ces articles n\'ont pas de prix pour votre compte. Retirez-les ou contactez-nous avant l\'envoi :', it: 'Questi articoli non hanno prezzo per il tuo account. Rimuovili o scrivici prima di inviare:' },
  // fotos
  photo_in:      { es: 'Foto en {color}', en: 'Photo in {color}', fr: 'Photo en {color}', it: 'Foto in {color}' },
  photos_of:     { es: 'Fotos de {name} en {color}', en: 'Photos of {name} in {color}', fr: 'Photos de {name} en {color}', it: 'Foto di {name} in {color}' },
  photo_soon:    { es: 'Foto próximamente', en: 'Photo coming soon', fr: 'Photo bientôt disponible', it: 'Foto in arrivo' },
  swatches_of:   { es: 'Colores de {name}', en: '{name} colours', fr: 'Couleurs de {name}', it: 'Colori di {name}' },
  more_colors:   { es: '{n} colores más: abrir ficha', en: '{n} more colours: open product', fr: '{n} couleurs de plus : ouvrir la fiche', it: '{n} colori in più: apri la scheda' },
  sheet_colors:  { es: 'Color', en: 'Colour', fr: 'Couleur', it: 'Colore' },
  close_sheet:   { es: 'Cerrar ficha', en: 'Close product', fr: 'Fermer la fiche', it: 'Chiudi la scheda' },
  // curvas
  curve_units:   { es: '{n} uds', en: '{n} units', fr: '{n} unités', it: '{n} pz' },
  // pedido nuevo
  reset_title:   { es: '¿Empezar un pedido nuevo?', en: 'Start a new order?', fr: 'Commencer une nouvelle commande ?', it: 'Iniziare un nuovo ordine?' },
  reset_text:    { es: 'Se borrará lo que tienes en pantalla.', en: 'What you have on screen will be cleared.', fr: 'Ce qui est à l\'écran sera effacé.', it: 'Quello che hai sullo schermo verrà cancellato.' },
  reset_ok:      { es: 'Empezar de nuevo', en: 'Start again', fr: 'Recommencer', it: 'Ricomincia' },
  // empresa y entrega (con sesión)
  co_title:      { es: 'Empresa y entrega', en: 'Company and delivery', fr: 'Société et livraison', it: 'Azienda e consegna' },
  co_company:    { es: 'Empresa', en: 'Company', fr: 'Société', it: 'Azienda' },
  co_choose:     { es: 'Elige la empresa con la que pides', en: 'Choose the company you are ordering for', fr: 'Choisissez la société qui commande', it: 'Scegli l\'azienda che ordina' },
  co_store:      { es: 'Tienda de entrega', en: 'Delivery store', fr: 'Boutique de livraison', it: 'Negozio di consegna' },
  co_store_choose:{ es: 'Elige una tienda', en: 'Choose a store', fr: 'Choisir une boutique', it: 'Scegli un negozio' },
  co_store_help: { es: 'Un pedido por tienda. Para otra tienda, haz otro pedido.', en: 'One order per store. For another store, place another order.', fr: 'Une commande par boutique. Pour une autre boutique, passez une autre commande.', it: 'Un ordine per negozio. Per un altro negozio, fai un altro ordine.' },
  co_po:         { es: 'Tu referencia de pedido (opcional)', en: 'Your PO number (optional)', fr: 'Votre référence de commande (facultatif)', it: 'Il tuo riferimento d\'ordine (facoltativo)' },
  co_comment:    { es: 'Comentario para SES (opcional)', en: 'Comment for SES (optional)', fr: 'Commentaire pour SES (facultatif)', it: 'Commento per SES (facoltativo)' },
  co_buyer:      { es: 'Comprador', en: 'Buyer', fr: 'Acheteur', it: 'Acquirente' },
  co_need_store: { es: 'Elige la tienda de entrega', en: 'Choose the delivery store', fr: 'Choisissez la boutique de livraison', it: 'Scegli il negozio di consegna' },
  co_need_company:{ es: 'Elige primero la empresa con la que pides', en: 'First choose the company you are ordering for', fr: 'Choisissez d\'abord la société qui commande', it: 'Scegli prima l\'azienda che ordina' },
  co_none:       { es: 'Tu cuenta aún no tiene una empresa asignada. Escríbenos a antonio@sespalma.com y lo resolvemos.', en: 'Your account has no company assigned yet. Write to antonio@sespalma.com and we will sort it out.', fr: 'Votre compte n\'a pas encore de société. Écrivez à antonio@sespalma.com.', it: 'Il tuo account non ha ancora un\'azienda. Scrivi a antonio@sespalma.com.' },
  co_cannot_order:{ es: 'Tu cuenta puede consultar el catálogo y los precios, pero no enviar pedidos. Escríbenos si lo necesitas.', en: 'Your account can view the catalogue and prices but cannot send orders. Contact us if you need it.', fr: 'Votre compte peut consulter le catalogue et les prix, mais pas commander. Contactez-nous si besoin.', it: 'Il tuo account può vedere catalogo e prezzi ma non inviare ordini. Scrivici se ti serve.' },
  no_access:     { es: 'Tu cuenta no tiene acceso todavía. Si crees que es un error, escríbenos.', en: 'Your account does not have access yet. If you think this is a mistake, contact us.', fr: 'Votre compte n\'a pas encore d\'accès. S\'il s\'agit d\'une erreur, contactez-nous.', it: 'Il tuo account non ha ancora accesso. Se pensi sia un errore, scrivici.' },
  catalog_error: { es: 'No hemos podido cargar el catálogo.', en: 'We could not load the catalogue.', fr: 'Impossible de charger le catalogue.', it: 'Non è stato possibile caricare il catalogo.' },
  co_view_as:    { es: 'Pedido en nombre de {name}: ves su catálogo, sus precios y su PVP, y el pedido llega a SES como suyo, a tu nombre como autor.', en: 'Ordering on behalf of {name}: you see their catalogue, prices and RRP, and the order reaches SES as theirs, with you as author.', fr: 'Commande au nom de {name} : vous voyez son catalogue, ses prix et son PVC, et la commande arrive chez SES comme la sienne, avec vous comme auteur.', it: 'Ordine a nome di {name}: vedi catalogo, prezzi e prezzo al pubblico, e l\'ordine arriva a SES come suo, con te come autore.' },
  co_viewas_other: { es: 'Pedir para otra empresa (Ver como…)', en: 'Order for another company (View as…)', fr: 'Commander pour une autre société (Voir en tant que…)', it: 'Ordina per un\'altra azienda (Vedi come…)' },
  co_admin_pick: { es: 'Eres administrador de SES. Elige una empresa para ver el catálogo con sus precios.', en: 'You are an SES administrator. Choose a company to see the catalogue with its prices.', fr: 'Vous êtes administrateur SES. Choisissez une société pour voir le catalogue avec ses prix.', it: 'Sei amministratore SES. Scegli un\'azienda per vedere il catalogo con i suoi prezzi.' },
  gate_title:    { es: 'Descubre la colección SS27', en: 'Discover the SS27 collection', fr: 'Découvrez la collection SS27', it: 'Scopri la collezione SS27' },
  gate_request:  { es: '¿Aún no tienes acceso?', en: 'No access yet?', fr: 'Pas encore d\'accès ?', it: 'Non hai ancora accesso?' },
  gate_request_btn:{ es: 'Solicitar acceso', en: 'Request access', fr: 'Demander un accès', it: 'Richiedi l\'accesso' },
  co_loading:    { es: 'Cargando tu cuenta…', en: 'Loading your account…', fr: 'Chargement de votre compte…', it: 'Caricamento del tuo account…' },
  co_error:      { es: 'No hemos podido cargar tu cuenta.', en: 'We could not load your account.', fr: 'Impossible de charger votre compte.', it: 'Non è stato possibile caricare il tuo account.' },
  orders_closed: { es: 'Pedidos cerrados', en: 'Orders closed', fr: 'Commandes closes', it: 'Ordini chiusi' },
  orders_closed_on: { es: 'Los pedidos {season} se cerraron el {date}. Escríbenos si necesitas algo.', en: '{season} orders closed on {date}. Contact us if you need anything.', fr: 'Les commandes {season} ont fermé le {date}. Contactez-nous si besoin.', it: 'Gli ordini {season} si sono chiusi il {date}. Scrivici se ti serve qualcosa.' },
  orders_until:  { es: 'Pedidos hasta el {date}', en: 'Orders until {date}', fr: 'Commandes jusqu\'au {date}', it: 'Ordini fino al {date}' },
  reload:        { es: 'Recargar la página', en: 'Reload the page', fr: 'Recharger la page', it: 'Ricarica la pagina' },
  // envío con sesión
  sent_ok:       { es: 'Pedido {ref} enviado. SES lo revisará y te avisará por email.', en: 'Order {ref} sent. SES will review it and email you.', fr: 'Commande {ref} envoyée. SES la vérifiera et vous préviendra par e-mail.', it: 'Ordine {ref} inviato. SES lo verificherà e ti avviserà via email.' },
  sent_replayed: { es: 'Este pedido ya estaba enviado ({ref}).', en: 'This order had already been sent ({ref}).', fr: 'Cette commande avait déjà été envoyée ({ref}).', it: 'Questo ordine era già stato inviato ({ref}).' },
  see_in_portal: { es: 'Ver en mi cuenta', en: 'View in my account', fr: 'Voir dans mon compte', it: 'Vedi nel mio account' },
  draft_already_sent: { es: 'Este borrador ya se envió desde otro dispositivo. Revísalo en tu cuenta antes de seguir; si quieres hacer otro pedido, pulsa «Guardar y enviar» de nuevo.', en: 'This draft was already sent from another device. Check it in your account first; to place another order, press "Save & send" again.', fr: 'Ce brouillon a déjà été envoyé depuis un autre appareil. Vérifiez-le dans votre compte ; pour passer une autre commande, appuyez de nouveau sur « Enregistrer et envoyer ».', it: 'Questa bozza è già stata inviata da un altro dispositivo. Controllala nel tuo account; per fare un altro ordine premi di nuovo "Salva e invia".' },
  draft_saved_server:  { es: 'Borrador guardado en tu cuenta.', en: 'Draft saved to your account.', fr: 'Brouillon enregistré dans votre compte.', it: 'Bozza salvata nel tuo account.' },
  draft_loaded_server: { es: 'Hemos recuperado el borrador guardado en tu cuenta.', en: 'We restored the draft saved in your account.', fr: 'Nous avons restauré le brouillon de votre compte.', it: 'Abbiamo ripristinato la bozza salvata nel tuo account.' },
};

function t(key, vars) {
  const e = I18N[key];
  if (!e) return B2B && B2B.has(key) ? B2B.t(key, vars) : key;
  let s = e[state.lang] || e.es || key;
  if (vars) s = s.replace(/\{(\w+)\}/g, (m, k) => (vars[k] != null ? vars[k] : m));
  return s;
}

function initLang() {
  if (B2B) { state.lang = B2B.getLang(); return; }
  let saved = null;
  try { saved = localStorage.getItem(LANG_KEY); } catch (_) {}
  if (LANGS.includes(saved)) { state.lang = saved; return; }
  const nav = (navigator.language || 'es').slice(0, 2).toLowerCase();
  state.lang = LANGS.includes(nav) ? nav : 'es';
}

function translateStatic(root) {
  const r = root || document;
  r.querySelectorAll('[data-i18n]').forEach((el) => { el.textContent = t(el.getAttribute('data-i18n')); });
  r.querySelectorAll('[data-i18n-ph]').forEach((el) => { el.setAttribute('placeholder', t(el.getAttribute('data-i18n-ph'))); });
  r.querySelectorAll('[data-i18n-title]').forEach((el) => { el.setAttribute('title', t(el.getAttribute('data-i18n-title'))); });
}

function setLang(lang) {
  if (!LANGS.includes(lang) || lang === state.lang) return;
  if (B2B) { B2B.setLang(lang); return; } // avisa a onLang → applyLang
  state.lang = lang;
  try { localStorage.setItem(LANG_KEY, lang); } catch (_) {}
  applyLang();
}

function applyLang() {
  document.documentElement.lang = state.lang;
  translateStatic();
  applyHero();
  renderFilters();
  renderAuthGate();
  renderBuyer();
  renderCatalog();
  updateSummary();
  updateLangSwitch();
  updateActionButtons();
  // si hay una ficha o el resumen abiertos, refrescarlos
  const sheet = byId('productSheet');
  if (sheet && !sheet.hidden && state.activeStyle) selectColor(state.activeColorIdx);
  const rev = byId('reviewModal');
  if (rev && !rev.hidden) renderReview();
}

function updateLangSwitch() {
  renderGate();
  const box = byId('langSwitch');
  if (!box) return;
  box.querySelectorAll('button[data-lang]').forEach((b) => {
    b.classList.toggle('active', b.dataset.lang === state.lang);
  });
}

/* ---------- carga ---------- */
async function boot() {
  const _d = window.SES_DATA || {};
  // ses-data.js solo trae configuración no sensible: el catálogo y los textos de la colección
  // llegan de Supabase (portal_catalog) después de entrar.
  state.config = _d.config || {};
  state.config.order = state.config.order || {};
  state.config.brand = state.config.brand || {};
  state.catalog = [];
  state.terms = _d.terms || null;
  if (state.terms) {
    const document = state.terms;
    computeTermsHash(document).then((h) => { if (state.terms === document) { state.termsHash = h; if (state.auth.rules) paintAuth(); } });
  }
  if (_d.logo && String(_d.logo).startsWith('data:image')) state.logoDataUrl = _d.logo;
  initLang();
  initCurve();
  applyBrand();
  wireEvents();
  wireGate();
  translateStatic();
  updateLangSwitch();
  if (!B2B) { showGate('error', 'network'); return; }
  showGate('loading');
  initAuth();
}

/* ---------- acceso primero: sin sesión solo se ve el login ---------- */
let appBooted = false;

function wireGate() {
  qsa('#loginGate [data-lang]').forEach((b) => b.addEventListener('click', () => setLang(b.dataset.lang)));
}

// mode: 'loading' | 'login' | 'noaccess' | 'error'
function showGate(mode, code) {
  state.gate = { mode, code };
  const gate = byId('loginGate');
  const app = byId('orderApp');
  if (app) app.hidden = true;
  if (!gate) return;
  gate.hidden = false;
  renderGate();
}

function renderGate() {
  const gate = byId('loginGate');
  if (!gate || gate.hidden || !state.gate) return;
  const box = byId('lgAuth');
  const title = byId('lgTitle');
  if (title) title.textContent = F('gateBlur') ? t('gate_title') : t('auth_title');
  qsa('#loginGate [data-lang]').forEach((b) => b.setAttribute('aria-pressed', b.dataset.lang === state.lang ? 'true' : 'false'));
  const { mode, code } = state.gate;
  // no repintar si nada cambia: se perdería lo que el comprador está escribiendo
  const key = `${mode}|${code || ''}|${state.lang}`;
  if (box.dataset.key === key) return;
  box.dataset.key = key;
  if (mode === 'login') {
    const typed = box.querySelector('input[type="email"]');
    const email = typed ? typed.value : '';
    B2B.renderAuthForm(box, { mode: 'login', autofocus: false, onDone: () => refreshAuth() });
    const fresh = box.querySelector('input[type="email"]');
    if (fresh && email) fresh.value = email;
    if (F('gateBlur')) {
      box.insertAdjacentHTML('beforeend', `<div class="lg-request"><p>${esc(t('gate_request'))}</p>
        <a class="b2b-btn b2b-btn--secondary b2b-btn--block" href="${B2B.ACCESS_MAILTO}">${esc(t('gate_request_btn'))}</a></div>`);
    }
    return;
  }
  if (mode === 'loading') {
    box.innerHTML = `<p class="lg-status" role="status">${esc(t('co_loading'))}</p>`;
    return;
  }
  const msg = mode === 'noaccess' ? t('no_access') : `${t('catalog_error')} ${B2B ? B2B.errorMessage(code) : ''}`;
  box.innerHTML = `
    <p class="lg-msg${mode === 'error' ? ' lg-msg--err' : ''}">${esc(msg)}</p>
    <div class="lg-actions">
      ${mode === 'error' ? `<button type="button" class="b2b-btn b2b-btn--primary b2b-btn--block" data-lg="retry">${esc(t('retry'))}</button>` : ''}
      ${mode === 'noaccess' ? `<a class="b2b-btn b2b-btn--secondary b2b-btn--block" href="${B2B.ACCESS_MAILTO}">antonio@sespalma.com</a>` : ''}
      <button type="button" class="b2b-btn b2b-btn--ghost b2b-btn--block" data-lg="logout">${esc(t('acc_logout'))}</button>
    </div>`;
  const r = box.querySelector('[data-lg="retry"]');
  if (r) r.addEventListener('click', () => { state.auth.me = null; state.auth.session = null; showGate('loading'); refreshAuth(); });
  const lo = box.querySelector('[data-lg="logout"]');
  if (lo) lo.addEventListener('click', () => B2B.signOut());
}

async function loadCatalog() {
  const sb = sbClient();
  if (!sb) throw Object.assign(new Error('network'), { code: 'network' });
  const { data, error } = await sb.from('portal_catalog').select('data').eq('season', season()).single();
  if (error) throw error;
  if (!data || !data.data || !Array.isArray(data.data.catalog)) throw Object.assign(new Error('not_found'), { code: 'not_found' });
  return data.data;
}

// Arranca la página de pedidos con el catálogo de portal_catalog (una sola vez por carga).
function bootApp(row) {
  if (appBooted) return;
  appBooted = true;
  state.catalog = row.catalog;
  state.config.collection = row.collection || {};
  state.config.order.sizeCurves = row.sizeCurves || null;
  indexSkus();
  applyHero();
  // la cesta antigua sin dueño (versiones anteriores) no se reutiliza: podía ser de otra cuenta
  try { localStorage.removeItem(STORE_KEY); } catch (_) { /* */ }
  renderFilters();
  renderCatalog();
  updateBuyerSummary();
  translateStatic();
  updateSummary();
  updateActionButtons();
  initCookieOffset();
  byId('loginGate').hidden = true;
  byId('orderApp').hidden = false;
  const bar = qs('.b2b-bar');
  if (bar) bar.hidden = false;
  openDeepLink();
  showHandoff();
  if (location.hash === '#pedido' && totals().units > 0) openReview();
}

function indexSkus() {
  for (const st of state.catalog) {
    for (const c of st.colors) {
      for (const sz of c.sizes) {
        state.skuMeta[sz.sku] = {
          styleCode: st.code, styleName: st.name, type: st.product_type,
          color: c.name, hex: c.hex, size: sz.size,
        };
      }
    }
  }
}

function applyBrand() {
  const b = state.config.brand;
  const root = APP_ROOT.style;
  if (b.primaryColor) root.setProperty('--color-ink', b.primaryColor);
  if (b.accentColor) root.setProperty('--color-accent', b.accentColor);
  if (b.paperColor) root.setProperty('--color-bg', b.paperColor);
  const bs = byId('brandSeason');
  if (bs) bs.textContent = b.season || '';
  const sl = byId('seasonLabel');
  if (sl) sl.textContent = b.season || '';
  document.title = `${b.name || 'SES'} · Pedidos ${b.season || ''}`.trim();
}

function initCurve() {
  // curva única antigua (interruptor de curvas apagado)
  const def = (state.config.order && state.config.order.sizeCurve) || {};
  state.curve = Object.assign({}, def);
  try {
    const saved = JSON.parse(localStorage.getItem('ses_curve_v1') || 'null');
    if (saved && typeof saved === 'object') state.curve = saved;
  } catch (_) { /* */ }
  // curvas por familia de tallas (la v1 no se reutiliza: era una sola curva para todo)
  try {
    const saved = JSON.parse(localStorage.getItem(CURVE_KEY) || 'null');
    if (saved && typeof saved === 'object') state.curveOverrides = saved;
  } catch (_) { /* */ }
}

function applyHero() {
  const b = state.config.brand || {};
  const col = state.config.collection || {};
  const links = state.config.links || {};
  const set = (id, txt) => { const el = byId(id); if (el && txt) el.textContent = txt; };
  // subtítulo traducido desde portal_catalog (collection.subtitle_i18n); si falta, se traduce
  // «Spring / Summer AAAA» aquí y, si no, se deja tal cual
  const sub = col.subtitle || b.seasonLabel || '';
  const ss = /^Spring\s*\/\s*Summer\s+(\d{4})$/i.exec(sub);
  set('heroSub', (col.subtitle_i18n && col.subtitle_i18n[state.lang]) || (ss ? t('season_ss', { year: ss[1] }) : sub));
  set('heroTitle', col.title || '');
  const intro = (F('heroI18n') && col.intro_i18n && col.intro_i18n[state.lang]) || col.intro || '';
  set('heroIntro', intro);
  const box = byId('heroLinks');
  if (box) {
    const items = [];
    const lb = safeUrl(links.lookbook);
    const ws = safeUrl(links.website);
    if (lb) items.push(`<a class="hero-link" href="${esc(lb)}" target="_blank" rel="noopener">${esc(t('lookbook'))}</a>`);
    // linesheet con los precios de la empresa que ha entrado (se genera en el navegador, nunca está publicado)
    if (state.auth.session && state.catalog.length) items.push(`<button type="button" class="hero-link ghost" id="btnLinesheet">${esc(t('linesheet'))}</button>`);
    // hoja de pedido en Excel (ida y vuelta): descargar con precios y subir para cargar cantidades
    if (F('excel') && state.auth.session && state.catalog.length) {
      items.push(`<button type="button" class="hero-link ghost" id="btnXlsDown">${esc(t('xls_download'))}</button>`);
      if (canOrder()) items.push(`<button type="button" class="hero-link ghost" id="btnXlsUp">${esc(t('xls_upload'))}</button>`);
    }
    if (ws) items.push(`<a class="hero-link ghost" href="${esc(ws)}" target="_blank" rel="noopener">sespalma.com ↗</a>`);
    box.innerHTML = items.join('');
    const btnLs = byId('btnLinesheet');
    if (btnLs) btnLs.addEventListener('click', () => downloadLinesheet(btnLs));
    const btnXd = byId('btnXlsDown');
    if (btnXd) btnXd.addEventListener('click', () => downloadOrderExcel(btnXd));
    const btnXu = byId('btnXlsUp');
    if (btnXu) btnXu.addEventListener('click', () => openUploadPanel());
  }
  applyOrderWindow();
}

// ventana de pedidos: "Pedidos hasta el 15 oct 2026 · Entregas desde el 15 feb 2027"
function fmtDate(iso) {
  if (!iso) return '';
  const [y, m, d] = String(iso).split('-').map(Number);
  if (!y || !m || !d) return iso;
  const locale = { es: 'es-ES', en: 'en-GB', fr: 'fr-FR', it: 'it-IT' }[state.lang] || 'es-ES';
  return new Date(y, m - 1, d).toLocaleDateString(locale, { day: 'numeric', month: 'short', year: 'numeric' });
}

function applyOrderWindow() {
  const el = byId('heroWindow');
  if (!el) return;
  const ow = state.config.orderWindow || {};
  if (!ow.show || (!ow.orderDeadline && !ow.deliveryStart)) { el.hidden = true; return; }
  const parts = [];
  const ru = state.auth && state.auth.session && state.auth.rules;
  // con sesión manda el plazo del servidor (portal_order_rules.submit_until)
  if (ru && ru.submit_until && B2B) parts.push(`<span class="hw-item"><span class="hw-label">${t('ow_order')}</span> <strong>${esc(B2B.fmtDate(ru.submit_until))}</strong></span>`);
  else if (ow.orderDeadline) parts.push(`<span class="hw-item"><span class="hw-label">${t('ow_order')}</span> <strong>${esc(fmtDate(ow.orderDeadline))}</strong></span>`);
  if (ow.deliveryStart) parts.push(`<span class="hw-item"><span class="hw-label">${t('ow_delivery')}</span> <strong>${esc(fmtDate(ow.deliveryStart))}</strong></span>`);
  el.innerHTML = parts.join('<span class="hw-sep" aria-hidden="true">·</span>');
  el.hidden = false;
}

/* ---------- sesión del portal: empresa, tiendas y precios propios ---------- */
// Los precios solo existen en memoria y solo con sesión iniciada. Sin sesión: catálogo sin precios.
let barCtl = null;
let authRun = null;

function season() { return (state.config.brand && state.config.brand.season) || 'SS27'; }
function sbClient() { return B2B ? B2B.sb() : null; }

function pricesOn() {
  const a = state.auth;
  return !!(a.session && a.pricesLoaded && a.prices.size);
}
function showBrowsePrices() { return F('pricesBrowse') && pricesOn(); }
function canOrder() {
  const co = state.auth.company;
  return !!(state.auth.session && co && co.can_order);
}
function skuPrice(sku) {
  const p = state.auth.prices.get(sku);
  return p && p.w > 0 ? p : null;
}
function fmtP(n, cur) { return B2B ? B2B.fmtPrice(n, cur) : ''; }

// Moneda local (portal_prices.wholesale_local, la calcula el CRM con el tipo de la tarifa):
// se enseña primero y debajo el precio de facturación (EUR). Sin local, solo el de facturación.
function localPrice(p) { return p && p.wl > 0 && p.lc ? { n: p.wl, cur: p.lc } : null; }

// Precio de un estilo para la tarjeta: { main, sub }. main en moneda local si la hay
// («Desde …» si varía entre variantes); sub = el de facturación.
function stylePriceParts(st) {
  let min = null, max = 0;
  for (const c of st.colors) for (const sz of c.sizes) {
    const p = skuPrice(sz.sku);
    if (!p) continue;
    if (!min || p.w < min.w) min = p;
    if (p.w > max) max = p.w;
  }
  if (!min) return { main: '', sub: '' };
  const from = (txt) => (txt && max > min.w + 0.004 ? t('from_price', { price: txt }) : txt);
  const loc = localPrice(min);
  const eur = fmtP(min.w, min.cur);
  return loc ? { main: from(fmtP(loc.n, loc.cur)), sub: eur } : { main: from(eur), sub: '' };
}
function stylePriceLabel(st) { return stylePriceParts(st).main; }
// «4.644,00 AED · 1.032,00 €» (o solo el de facturación)
function dualAmount(a) {
  const eur = fmtP(a.amount, a.currency);
  return a.localCurrency && eur ? `${fmtP(a.local, a.localCurrency)} · ${eur}` : eur;
}

// Importe del pedido con los precios de la cuenta. missing = SKUs con unidades y sin precio.
function orderAmount(filterStyle) {
  let amount = 0;
  let cur = 'EUR';
  let local = 0, localCur = null, localOk = null; // local solo si TODAS las líneas lo tienen
  const missing = [];
  for (const sku in state.qty) {
    const q = state.qty[sku];
    if (!q) continue;
    if (filterStyle) {
      const m = state.skuMeta[sku];
      if (!m || m.styleCode !== filterStyle.code) continue;
    }
    const p = skuPrice(sku);
    if (p) {
      amount += q * p.w; cur = p.cur;
      const loc = localPrice(p);
      if (loc && localOk !== false && (!localCur || localCur === loc.cur)) { local += q * loc.n; localCur = loc.cur; } else localOk = false;
    } else missing.push(sku);
  }
  const lc = localOk !== false && localCur ? localCur : null;
  return { amount: Math.round(amount * 100) / 100, currency: cur, local: lc ? Math.round(local * 100) / 100 : null, localCurrency: lc, missing };
}

function skuLabel(sku) {
  const m = state.skuMeta[sku];
  return m ? `${m.styleName} · ${m.color} · ${m.size}` : sku;
}

// País (ISO) de las tiendas de entrega elegidas; si no hay ninguna elegida, todas las de la empresa.
function rrpCountries() {
  const co = state.auth.company;
  if (!co) return [];
  // PVP del país de la tienda de entrega elegida (con una sola tienda ya está elegida)
  const st = (co.stores || []).find((s) => s.id === state.auth.storeIds[0]);
  return st && st.country_code ? [st.country_code] : [];
}

function resetAuthState() {
  const a = state.auth;
  a.session = null; a.me = null; a.loading = false; a.error = null;
  a.companyId = null; a.company = null; a.storeIds = []; a.storeError = false;
  a.prices = new Map(); a.rrp = new Map(); a.pricesLoaded = false; a.priceError = null;
  a.draftRequestId = null; a.po = ''; a.comment = ''; a.rules = null;
  applyOrderWindow();
}

function initAuth() {
  if (!B2B) return;
  barCtl = B2B.mountBar(qs('.b2b-bar'), {
    page: 'order', portalUrl: PORTAL_URL,
    onLogin: doLogin,
    onLogout: () => { /* onAuth(SIGNED_OUT) repinta */ },
  });
  B2B.onLang((l) => {
    state.lang = l; applyLang();
    if (state.auth.me) B2B.paintViewAs(state.auth.me, { root: APP_ROOT, onChange: () => location.reload() });
  });
  B2B.onAuth((event) => {
    if (event === 'SIGNED_OUT') { onSignedOut(); return; }
    if (event === 'SIGNED_IN' || event === 'USER_UPDATED') refreshAuth();
  });
  refreshAuth();
}

async function doLogin() {
  if (!B2B) return;
  const ok = await B2B.openLogin({ root: APP_ROOT });
  if (ok) await refreshAuth();
}

function onSignedOut() {
  resetAuthState();
  state.buyer = {};
  saveDraft();
  if (barCtl) barCtl.setSession(null);
  // con el catálogo ya cargado, se recarga la página: fuera de memoria y del DOM, y vuelve el acceso
  if (appBooted) { location.reload(); return; }
  showGate('login');
}

function refreshAuth() {
  if (authRun) return authRun;
  authRun = (async () => {
    const session = await B2B.getSession();
    const a = state.auth;
    if (!session) { onSignedOut(); return; }
    const sameUser = a.session && a.session.user && a.session.user.id === session.user.id && a.me;
    a.session = session;
    if (barCtl) barCtl.setSession(session);
    if (sameUser && appBooted) return;
    a.loading = true; a.error = null;
    if (!appBooted) showGate('loading');
    try {
      a.me = await B2B.me(true);
    } catch (e) {
      a.loading = false;
      a.error = (e && e.code) || 'unknown';
      if (!appBooted) showGate('error', a.error); else paintAuth();
      return;
    }
    a.loading = false;
    B2B.paintViewAs(a.me, { root: APP_ROOT, onChange: () => location.reload() });
    // sin empresa asignada y sin rol de SES: no hay acceso al catálogo
    if (!(a.me.companies || []).length && !a.me.is_admin) { showGate('noaccess'); return; }
    if (!appBooted) {
      try { bootApp(await loadCatalog()); }
      catch (e) { showGate('error', (e && e.code && !/^PGRST|^\d/.test(e.code)) ? e.code : B2B.errorCode(e)); return; }
    }
    const id = B2B.chosenCompanyId(a.me);
    if (id) await selectCompany(id);
    else paintAuth();
  })().finally(() => { authRun = null; });
  return authRun;
}

async function selectCompany(id) {
  const a = state.auth;
  const list = (a.me && a.me.companies) || [];
  const co = list.find((c) => c.id === id) || null;
  a.companyId = co ? co.id : null;
  a.company = co;
  B2B.chooseCompany(a.companyId);
  a.storeIds = [];
  a.storeError = false;
  a.draftRequestId = null;
  if (co) {
    let saved = null;
    try { saved = JSON.parse(B2B.ss.get('ses_b2b_stores:' + co.id) || 'null'); } catch (_) { saved = null; }
    const valid = (co.stores || []).map((s) => s.id);
    a.storeIds = Array.isArray(saved) ? saved.filter((x) => valid.includes(x)).slice(0, 1) : [];
    if (valid.length === 1) a.storeIds = [valid[0]]; // una sola tienda: elegida sin preguntar
    try { a.draftRequestId = localStorage.getItem(draftReqKey()) || null; } catch (_) { a.draftRequestId = null; }
  }
  restoreDraft(); // cada empresa tiene su cesta
  syncBuyerFromCompany();
  paintAuth();
  if (!co) return;
  await Promise.all([loadPrices(), loadRules()]);
  await loadServerDraft();
}

function syncBuyerFromCompany() {
  const a = state.auth;
  if (!a.session) return;
  const co = a.company;
  const stores = co ? (co.stores || []).filter((s) => a.storeIds.includes(s.id)) : [];
  state.buyer = {
    company: co ? (co.legal_name || co.name) : '',
    email: (a.session.user && a.session.user.email) || '',
    country: stores.map((s) => `${s.name}${s.country_code ? ' (' + B2B.countryName(s.country_code) + ')' : ''}`).join(' · '),
    notes: a.comment || '',
    po: a.po || '',
  };
}

async function loadPrices() {
  const a = state.auth;
  const sb = sbClient();
  if (!sb || !a.companyId) return;
  const company = a.companyId;
  a.pricesLoaded = false; a.priceError = null; a.prices = new Map(); a.rrp = new Map();
  paintAuth();
  try {
    const cols = 'sku,style_code,wholesale,deposit,currency';
    const q = (sel) => B2B.selectAll(() => sb.from('portal_prices').select(sel).eq('company_id', company).eq('season', season()).order('sku'));
    let rows;
    try { rows = await q(cols + ',wholesale_local,local_currency'); } catch (_) { rows = await q(cols); }
    if (a.companyId !== company) return; // cambió de empresa mientras cargaba
    const prices = new Map();
    rows.forEach((r) => {
      const w = Number(r.wholesale);
      const wl = Number(r.wholesale_local);
      if (w > 0) prices.set(r.sku, { w, cur: r.currency || 'EUR', style: r.style_code, wl: wl > 0 ? wl : null, lc: wl > 0 ? r.local_currency : null });
    });
    // Empresa en firme y en depósito con precios distintos: los pedidos son en firme.
    const co = await sb.from('portal_companies').select('sale_models').eq('id', company).limit(1);
    const models = (co && !co.error && co.data && co.data[0] && co.data[0].sale_models) || [];
    // Solo se rotula "En firme" si el depósito tiene otro precio (si no, es el mismo).
    a.priceLabel = models.includes('FIRM') && models.includes('CONSIGNMENT') && rows.some((r) => Number(r.deposit) > 0)
      ? 'wholesale_firm' : 'wholesale';
    const rrp = new Map();
    const countries = [...new Set(((a.company && a.company.stores) || []).map((s) => s.country_code).filter(Boolean))];
    if (F('showRrp') && countries.length) {
      const rr = await B2B.selectAll(() => sb.from('portal_rrp')
        .select('country_code,sku,amount,currency,vat_included').eq('season', season()).in('country_code', countries).order('sku'));
      rr.forEach((r) => {
        if (!(Number(r.amount) > 0)) return;
        if (!rrp.has(r.country_code)) rrp.set(r.country_code, new Map());
        rrp.get(r.country_code).set(r.sku, { amount: Number(r.amount), cur: r.currency, vat: !!r.vat_included });
      });
    }
    if (a.companyId !== company) return;
    a.prices = prices; a.rrp = rrp; a.pricesLoaded = true;
  } catch (e) {
    a.priceError = B2B.errorCode(e);
  }
  paintAuth();
}

// Borrador guardado en la cuenta: se carga si en pantalla no hay nada (nunca pisa lo que hay).
async function loadServerDraft() {
  const a = state.auth;
  const sb = sbClient();
  if (!sb || !a.companyId || !canOrder()) return;
  try {
    const { data, error } = await sb.from('portal_requests')
      .select('id,draft_lines,delivery_store_ids,buyer_po,updated_at')
      .eq('company_id', a.companyId).eq('season', season()).eq('status', 'DRAFT')
      .order('updated_at', { ascending: false }).limit(1);
    if (error) throw error;
    const d = data && data[0];
    if (!d) { a.draftRequestId = null; rememberDraftId(null); return; }
    a.draftRequestId = d.id;
    rememberDraftId(d.id);
    if (totals().units > 0) return;
    const lines = Array.isArray(d.draft_lines) ? d.draft_lines : [];
    let n = 0;
    lines.forEach((l) => { const q = parseInt(l.qty, 10) || 0; if (q > 0 && state.skuMeta[l.sku]) { state.qty[l.sku] = q; n++; } });
    const valid = ((a.company && a.company.stores) || []).map((s) => s.id);
    const stores = (d.delivery_store_ids || []).filter((x) => valid.includes(x));
    if (stores.length) a.storeIds = [stores[0]];
    if (d.buyer_po) a.po = d.buyer_po;
    syncBuyerFromCompany();
    saveDraft();
    paintAuth();
    if (n) showToast(t('draft_loaded_server'), 'ok');
  } catch (e) {
    console.warn('borrador de la cuenta no disponible', e);
  }
}

// Reglas de la temporada (portal_order_rules): plazo de envío y versión de las condiciones vigentes.
let rulesLoad = 0;
async function loadRules() {
  const a = state.auth;
  if (!a.session) return;
  const session = a.session;
  const sequence = ++rulesLoad;
  const r = await B2B.rpc('portal_order_rules', { p_season: season() });
  if (sequence !== rulesLoad || a.session !== session) return;
  const rules = r.error ? { season: season(), enabled: false } : (r.data || { season: season(), enabled: false });
  if (rules.terms) {
    const hash = await computeTermsHash(rules.terms);
    if (sequence !== rulesLoad || a.session !== session) return;
    if (!hash || hash !== rules.terms_hash || rules.terms.version !== rules.terms_version) {
      a.rules = Object.assign({}, rules, { enabled: false });
      state.termsHash = null;
      state.termsAccepted = null;
    } else {
      if (state.termsHash !== hash || !state.terms || state.terms.version !== rules.terms_version) {
        state.termsAccepted = null;
        const modal = byId('termsModal');
        if (modal && !modal.hidden) closeTermsGate();
      }
      state.terms = rules.terms;
      state.termsHash = hash;
      a.rules = rules;
    }
  } else a.rules = rules; // Legacy documents are retained until the initial import.
  applyOrderWindow();
  paintAuth();
}
function ordersClosed() {
  const ru = state.auth.session && state.auth.rules;
  if (!ru) return false;
  if (!ru.enabled) return true;
  return !!(ru.submit_until && Date.now() > new Date(ru.submit_until).getTime());
}
// Las condiciones del asset (ses-data.js) no son las vigentes en el servidor: hay que recargar.
function termsOutdated() {
  const ru = state.auth.session && state.auth.rules;
  return !!(ru && ru.terms_version && (!state.terms || ru.terms_version !== state.terms.version || (ru.terms_hash && ru.terms_hash !== state.termsHash)));
}

function draftReqKey() {
  const a = state.auth;
  const uid = (a.session && a.session.user && a.session.user.id) || 'anon';
  return `ses_b2b_draft_req:${uid}:${a.companyId}`;
}

function rememberDraftId(id) {
  const co = state.auth.companyId;
  if (!co) return;
  try {
    if (id) localStorage.setItem(draftReqKey(), id);
    else localStorage.removeItem(draftReqKey());
  } catch (_) { /* */ }
}

// Repinta todo lo que depende de la sesión.
function paintAuth() {
  // los enlaces de la portada dependen de la sesión y de si la empresa puede pedir (subir Excel)
  if (appBooted) applyHero();
  maybeOpenUploadFromLink();
  renderAuthGate();
  renderBuyer();
  renderCatalog();
  updateSummary();
  updateActionButtons();
  const sheet = byId('productSheet');
  if (sheet && !sheet.hidden && state.activeStyle) { renderSheetPrice(); updateSheetCount(); }
  const rev = byId('reviewModal');
  if (rev && !rev.hidden) renderReview();
}

// Aviso de datos de facturación incompletos (core: B2B.billing): una línea encima del pedido, solo con sesión
// y empresa elegida; enlaza a «Datos» del portal (misma empresa: va en sessionStorage).
function renderBillingNotice() {
  if (!B2B || !B2B.billing) return;
  const app = byId('orderApp');
  if (!app) return;
  let slot = byId('billingNotice');
  if (!slot) {
    slot = document.createElement('div');
    slot.id = 'billingNotice';
    slot.className = 'billing-notice';
    slot.hidden = true;
    app.insertBefore(slot, app.firstChild);
  }
  const a = state.auth;
  B2B.billing.mount(slot, a.session && a.companyId ? { companyId: a.companyId, href: PORTAL_URL + '#/datos', focusAfter: byId('heroTitle') } : null);
}

// Aviso bajo el hero: sin sesión → «Inicia sesión…»; con sesión → estado de la cuenta y de los precios.
function renderAuthGate() {
  renderBillingNotice();
  const box = byId('authGate');
  if (!box) return;
  const a = state.auth;
  const esc2 = esc;
  let html = '';
  if (!a.session) {
    box.hidden = true; return; // sin sesión no se llega aquí: la página es solo el acceso
    html = `
      <div class="ag-icon" aria-hidden="true">${B2B.ICON.lock}</div>
      <div class="ag-body">
        <h2 class="ag-title">${esc2(t('gate_title'))}</h2>
        <p class="ag-text">${esc2(t('gate_text'))}</p>
        <div class="ag-actions">
          <button type="button" class="b2b-btn b2b-btn--primary" data-gate="login">${esc2(t('gate_btn'))}</button>
          <a class="b2b-link" href="${B2B.ACCESS_MAILTO}">${esc2(t('auth_request'))}</a>
        </div>
      </div>`;
  } else if (a.loading) {
    html = `<p class="ag-status" role="status">${esc2(t('co_loading'))}</p>`;
  } else if (a.error) {
    html = `<div class="ag-body"><p class="ag-text ag-err">${esc2(t('co_error'))} ${esc2(B2B.errorMessage(a.error))}</p>
      <div class="ag-actions"><button type="button" class="b2b-btn b2b-btn--secondary" data-gate="retry">${esc2(t('retry'))}</button></div></div>`;
  } else if (a.me && !(a.me.companies || []).length && a.me.is_admin) {
    html = `<div class="ag-body"><p class="ag-text">${esc2(t('co_admin_pick'))}</p>
      <div class="ag-actions"><button type="button" class="b2b-btn b2b-btn--secondary" data-gate="viewas">${esc2(t('va_btn'))}</button></div></div>`;
  } else if (a.me && !(a.me.companies || []).length) {
    html = `<p class="ag-text">${esc2(t('co_none'))}</p>`;
  } else if (!a.company) {
    html = `<p class="ag-text">${esc2(t('co_need_company'))}</p>`;
  } else if (!a.company.can_order) {
    html = `<p class="ag-text">${esc2(t('co_cannot_order'))}</p>`;
  } else if (ordersClosed()) {
    const ru = a.rules;
    html = `<p class="ag-text ag-err">${esc2(ru.enabled && ru.submit_until ? t('orders_closed_on', { season: season(), date: B2B.fmtDateTime(ru.submit_until) }) : B2B.errorMessage('season_closed'))}</p>`;
  } else if (termsOutdated()) {
    html = `<div class="ag-body"><p class="ag-text ag-err">${esc2(B2B.errorMessage('terms_outdated'))}</p>
      <div class="ag-actions"><button type="button" class="b2b-btn b2b-btn--secondary" data-gate="reload">${esc2(t('reload'))}</button></div></div>`;
  } else if (a.priceError) {
    html = `<div class="ag-body"><p class="ag-text ag-err">${esc2(t('prices_error'))} ${esc2(B2B.errorMessage(a.priceError))}</p>
      <div class="ag-actions"><button type="button" class="b2b-btn b2b-btn--secondary" data-gate="prices">${esc2(t('retry'))}</button></div></div>`;
  } else if (!a.pricesLoaded) {
    html = `<p class="ag-status" role="status">${esc2(t('prices_loading'))}</p>`;
  } else if (!a.prices.size) {
    html = `<p class="ag-text">${esc2(t('prices_empty', { season: season() }))}</p>`;
  } else if (a.company.view_as) {
    html = `<p class="ag-text">${esc2(t('co_view_as', { name: a.company.name }))}</p>`;
  }
  box.innerHTML = html;
  box.hidden = !html;
  box.classList.toggle('auth-gate--quiet', !!a.session);
  const login = box.querySelector('[data-gate="login"]');
  if (login) login.addEventListener('click', doLogin);
  const retry = box.querySelector('[data-gate="retry"]');
  if (retry) retry.addEventListener('click', () => { state.auth.me = null; state.auth.error = null; state.auth.session = null; refreshAuth(); });
  const rl = box.querySelector('[data-gate="reload"]');
  if (rl) rl.addEventListener('click', () => location.reload());
  const va = box.querySelector('[data-gate="viewas"]');
  if (va) va.addEventListener('click', async () => {
    const id = await B2B.pickViewAs({ root: APP_ROOT });
    if (!id) return;
    B2B.setViewAs(id);
    location.reload();
  });
  const rp = box.querySelector('[data-gate="prices"]');
  if (rp) rp.addEventListener('click', loadPrices);
}

// Tarjeta «Empresa y entrega» (con sesión): empresa, tiendas, referencia y comentario.
function renderCompanyCard(grid) {
  const a = state.auth;
  const list = (a.me && a.me.companies) || [];
  const uid = 'co';
  if (!a.me) { grid.innerHTML = `<p class="co-meta">${esc(t('co_loading'))}</p>`; return; }
  const co = a.company;
  const companyField = list.length > 1
    ? `<div class="field full"><label for="${uid}Company">${esc(t('co_company'))}</label>
        <select id="${uid}Company" class="co-select">
          <option value="">${esc(t('co_choose'))}</option>
          ${list.map((c) => `<option value="${esc(c.id)}"${co && co.id === c.id ? ' selected' : ''}>${esc(c.name)}</option>`).join('')}
        </select></div>`
    : `<div class="field full"><span class="co-label">${esc(t('co_company'))}</span><p class="co-static">${esc(co ? (co.legal_name || co.name) : '')}</p></div>`;
  // El admin elige siempre para quién pide, aunque sea miembro de alguna empresa (p. ej. la de pruebas).
  const viewAsField = a.me && a.me.is_admin
    ? `<div class="field full"><button type="button" class="b2b-btn b2b-btn--secondary" data-co="viewas">${esc(t('co_viewas_other'))}</button></div>`
    : '';
  const stores = co ? (co.stores || []) : [];
  // Una sola tienda de entrega por pedido (el CRM pone en cuarentena los pedidos con varias o ninguna).
  const storeLabel = (st) => `${st.name}${st.country_code ? ' · ' + B2B.countryName(st.country_code) : ''}`;
  let storesField = '';
  if (stores.length === 1) {
    storesField = `<div class="field full"><span class="co-label">${esc(t('co_store'))}</span><p class="co-static">${esc(storeLabel(stores[0]))}</p></div>`;
  } else if (stores.length > 1) {
    storesField = `<div class="field full co-stores${a.storeError ? ' input-error' : ''}">
      <label for="${uid}Store">${esc(t('co_store'))} <span class="req">*</span></label>
      <select id="${uid}Store" class="co-select" required aria-required="true">
        <option value="">${esc(t('co_store_choose'))}</option>
        ${stores.map((st) => `<option value="${esc(st.id)}"${a.storeIds[0] === st.id ? ' selected' : ''}>${esc(storeLabel(st))}</option>`).join('')}
      </select>
      <p class="co-help">${esc(t('co_store_help'))}</p>
    </div>`;
  }
  const sync = (a.me && a.me.last_sync ? `<span>${esc(t('prices_updated', { date: B2B.fmtDateTime(a.me.last_sync) }))}</span>` : '')
    + (a.rules && a.rules.enabled && a.rules.submit_until && !ordersClosed() ? `<span>${esc(t('orders_until', { date: B2B.fmtDateTime(a.rules.submit_until) }))}</span>` : '');
  grid.innerHTML = `
    ${companyField}
    ${viewAsField}
    ${co ? storesField : ''}
    ${co && co.can_order ? `
      <div class="field"><label for="${uid}Po">${esc(t('co_po'))}</label>
        <input id="${uid}Po" type="text" maxlength="100" autocomplete="off" value="${esc(a.po)}" /></div>
      <div class="field full"><label for="${uid}Comment">${esc(t('co_comment'))}</label>
        <textarea id="${uid}Comment" maxlength="2000">${esc(a.comment)}</textarea></div>` : ''}
    <p class="co-meta field full"><span>${esc(t('co_buyer'))}: ${esc((a.session.user && a.session.user.email) || '')}</span>${sync}</p>`;
  const sel = grid.querySelector('#' + uid + 'Company');
  if (sel) sel.addEventListener('change', () => selectCompany(sel.value || null));
  const vaBtn = grid.querySelector('[data-co="viewas"]');
  if (vaBtn) vaBtn.addEventListener('click', async () => {
    const id = await B2B.pickViewAs({ root: APP_ROOT });
    if (!id) return;
    B2B.setViewAs(id);
    location.reload();
  });
  const storeSel = grid.querySelector('#' + uid + 'Store');
  if (storeSel) storeSel.addEventListener('change', () => {
    a.storeIds = storeSel.value ? [storeSel.value] : [];
    a.storeError = false;
    B2B.ss.set('ses_b2b_stores:' + a.companyId, JSON.stringify(a.storeIds));
    grid.querySelector('.co-stores').classList.remove('input-error');
    syncBuyerFromCompany();
    updateBuyerSummary();
    renderCatalog();
    const sheet = byId('productSheet');
    if (sheet && !sheet.hidden) renderSheetPrice();
  });
  const po = grid.querySelector('#' + uid + 'Po');
  if (po) po.addEventListener('input', () => { a.po = po.value; syncBuyerFromCompany(); });
  const cm = grid.querySelector('#' + uid + 'Comment');
  if (cm) cm.addEventListener('input', () => { a.comment = cm.value; syncBuyerFromCompany(); });
}

// Botones de la barra del pedido según la sesión.
function updateActionButtons() {
  const send = byId('btnSend');
  const send2 = byId('btnSend2');
  const draftBar = byId('btnDraftBar');
  const draftModal = byId('btnDraftSave');
  const anonLocked = !state.auth.session && !!B2B;
  const units = totals().units;
  const closed = !!state.auth.session && (ordersClosed() || termsOutdated());
  [send, send2].forEach((b) => {
    if (!b || b.getAttribute('aria-busy') === 'true') return;
    b.textContent = anonLocked ? t('login_to_order') : (closed && ordersClosed() ? t('orders_closed') : t('send'));
    b.disabled = anonLocked ? false : (units === 0 || closed);
  });
  [draftBar, draftModal].forEach((b) => {
    if (!b) return;
    b.hidden = anonLocked || (!!state.auth.session && !canOrder());
    if (b.getAttribute('aria-busy') !== 'true') b.disabled = units === 0;
  });
  const review = byId('btnReview');
  if (review) review.disabled = units === 0;
  // móvil: la barra solo lleva «Revisar y enviar»; sin sesión se queda el botón de entrar
  const bar = byId('summaryBar');
  if (bar) bar.classList.toggle('is-anon', anonLocked);
  ['btnReset', 'btnReset2'].forEach((id) => { const r = byId(id); if (r) r.disabled = units === 0; });
  // motivo visible de por qué no se puede enviar
  const hint = byId('summaryHint');
  if (hint) {
    let why = '';
    if (state.auth.session && ordersClosed()) why = t('orders_closed');
    else if (state.auth.session && termsOutdated()) why = B2B.errorMessage('terms_outdated');
    else if (units === 0) why = t('hint_add_units');
    hint.textContent = why;
    hint.hidden = !why;
  }
}

/* ---------- aviso de cookies: la barra del pedido sube por encima ---------- */
function initCookieOffset() {
  if (!F('cookieOffset')) return;
  const SEL = '#shopify-pc__banner, .shopify-pc__banner, [id^="shopify-pc__banner"]';
  let current = null;
  let ro = null;
  let raf = 0;
  function measure() {
    const el = document.querySelector(SEL);
    let h = 0;
    if (el) {
      const r = el.getBoundingClientRect();
      const cs = getComputedStyle(el);
      const visible = cs.display !== 'none' && cs.visibility !== 'hidden' && Number(cs.opacity) > 0 && r.height > 0;
      if (visible && r.bottom >= window.innerHeight - 4) h = Math.max(0, Math.round(window.innerHeight - r.top));
    }
    APP_ROOT.style.setProperty('--ses-cookie-h', h + 'px');
  }
  function watch() {
    raf = 0;
    const el = document.querySelector(SEL);
    if (el !== current) {
      if (ro) ro.disconnect();
      current = el;
      if (el && window.ResizeObserver) { ro = new ResizeObserver(measure); ro.observe(el); }
    }
    measure();
  }
  const schedule = () => { if (!raf) raf = requestAnimationFrame(watch); };
  if (window.MutationObserver) new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
  document.addEventListener('visitorConsentCollected', () => setTimeout(watch, 60));
  window.addEventListener('resize', schedule);
  watch();
}

/* ---------- pedido cargado desde el portal («Repetir pedido») ---------- */
function showHandoff() {
  if (!B2B) return;
  const raw = B2B.ss.get(HANDOFF_KEY);
  if (!raw) return;
  B2B.ss.del(HANDOFF_KEY);
  try {
    const h = JSON.parse(raw);
    if (h && h.msg) B2B.toast(h.msg, h.list && h.list.length ? 'err' : 'ok', { root: APP_ROOT, list: h.list || [], ms: 12000 });
  } catch (_) { /* */ }
}

/* ---------- comprador ---------- */
// Sin sesión no hay datos de comprador: el pedido se hace siempre con la cuenta (empresa y tienda).
function renderBuyer() {
  const card = byId('buyerCard');
  const grid = byId('buyerGrid');
  const title = card && card.querySelector('.card-title');
  if (!state.auth.session) { if (card) card.hidden = true; grid.innerHTML = ''; return; }
  if (card) card.hidden = false;
  if (title) { title.setAttribute('data-i18n', 'co_title'); title.textContent = t('co_title'); }
  renderCompanyCard(grid);
  updateBuyerSummary();
}

/* ---------- bloque comprador plegable ---------- */
function toggleBuyerCard() {
  const card = byId('buyerCard');
  const btn = byId('buyerToggle');
  if (!card || !btn) return;
  const collapsed = card.classList.toggle('collapsed');
  btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
}

function updateBuyerSummary() {
  const el = byId('buyerSummary');
  if (!el) return;
  const parts = [];
  if (state.auth.session) {
    const co = state.auth.company;
    if (co) parts.push(co.name);
    const st = co && (co.stores || []).find((x) => x.id === state.auth.storeIds[0]);
    if (st) parts.push(st.name);
    el.textContent = parts.join(' · ');
    return;
  }
  if (state.buyer.company) parts.push(state.buyer.company);
  if (state.buyer.contact) parts.push(state.buyer.contact);
  el.textContent = parts.join(' · ');
}

/* ---------- filtros (agrupación reducida) ---------- */
const FILTER_GROUPS = [
  { key: 'all', label: 'Todo', types: null },
  { key: 'camisas', label: 'Camisas', types: ['Shirt', 'LongSleeveShirt', 'ShortSleeveShirt', 'Overshirt'] },
  { key: 'polos', label: 'Polos', types: ['Polo', 'TShirt'] },
  { key: 'pantalones', label: 'Pantalones', types: ['Trousers', 'ShortTrousers', 'SwimShort'] },
  { key: 'chaquetas', label: 'Chaquetas', types: ['Jacket', 'Vest', 'Sweater'] },
  { key: 'accesorios', label: 'Accesorios', types: ['Accessory', 'Espadrille', 'EspadrilleWedge', 'Moccasin', 'FlatSandal', 'HeeledSandal', 'Ballerina', 'BasketBag', 'PochetteBag', 'ToteBag'] },
];

function renderFilters() {
  const present = new Set(state.catalog.map((s) => s.product_type));
  const box = byId('typeFilters');
  box.innerHTML = '';
  for (const g of FILTER_GROUPS) {
    if (g.types && !g.types.some((ty) => present.has(ty))) continue;
    const chip = document.createElement('button');
    chip.className = 'chip' + (g.key === state.filterGroup ? ' active' : '');
    chip.textContent = t('filter_' + g.key);
    chip.addEventListener('click', () => {
      state.filterGroup = g.key;
      renderFilters();
      renderCatalog();
    });
    box.appendChild(chip);
  }
}

function prettyType(type) {
  const key = 'type_' + type;
  return I18N[key] ? t(key) : type;
}

// "5 colores" / "1 color" según idioma
function colorsLabel(n) {
  return `${n} ${n === 1 ? t('color_one') : t('color_many')}`;
}

/* ---------- catálogo ---------- */
function visibleStyles() {
  const q = state.search.trim().toLowerCase();
  const group = FILTER_GROUPS.find((g) => g.key === state.filterGroup);
  return state.catalog.filter((s) => {
    if (group && group.types && !group.types.includes(s.product_type)) return false;
    if (!q) return true;
    if (s.name.toLowerCase().includes(q) || s.code.toLowerCase().includes(q)) return true;
    return s.colors.some((c) => c.name.toLowerCase().includes(q));
  });
}

/* ----- rejilla de productos (lookbook con fotos) ----- */
// Reescribe URLs de imagen que apuntaban a GitHub Pages (caído) a los assets del tema.
// Un nombre de archivo suelto («b2bf-….jpg», las fotos encuadradas de portal_catalog) es un asset del tema.
function resolveImg(u) {
  if (u && window.SES_ASSET_BASE && /^[\w.-]+\.(jpe?g|png|webp)$/i.test(u)) return window.SES_ASSET_BASE + u;
  if (u && window.SES_ASSET_BASE && u.indexOf('github.io/ses-pedidos/catalog/img/') > -1) {
    return window.SES_ASSET_BASE + u.substring(u.lastIndexOf('/') + 1);
  }
  return u;
}

/* ----- fotos por color: propia, prestada («Foto en X») o ninguna ----- */
const slug = (v) => String(v || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '');
function imgOverride(st, c) {
  return safeUrl(resolveImg(window.SES_IMAGE_OVERRIDES && window.SES_IMAGE_OVERRIDES[`${st.code}:${c.name}`])) || null;
}
function colorImg(c) { return (c.image && safeUrl(resolveImg(c.image))) || null; }
// Fotos del color para la ficha: images (galería) o, en catálogos antiguos, solo image.
function colorImages(c) {
  const list = Array.isArray(c.images) && c.images.length ? c.images : (c.image ? [c.image] : []);
  return list.map((u) => safeUrl(resolveImg(u))).filter(Boolean);
}

// Dueño de una foto compartida por varios colores: el color cuyo nombre aparece en el archivo;
// si ninguno, el primero del catálogo que la usa.
function photoOwner(st, src) {
  const users = st.colors.filter((x) => !x.photoFrom && !imgOverride(st, x) && colorImg(x) === src);
  if (!users.length) return null;
  if (users.length === 1) return users[0];
  const file = slug(src.split('?')[0].split('/').pop());
  return users.find((x) => slug(x.name) && file.includes(slug(x.name))) || users[0];
}

// { src, own, shownIn } para el color idx. own=false + shownIn → rótulo «Foto en {shownIn}».
function photoFor(st, idx) {
  const c = st.colors[idx];
  if (!c) return { src: null, own: false };
  const ov = imgOverride(st, c);
  if (ov) return { src: ov, own: true };
  // color sin foto propia: el catálogo dice de qué color es la que se enseña («Foto en X»)
  if (c.photoFrom) {
    const from = st.colors.find((x) => x.name === c.photoFrom);
    const src = (from && colorImg(from)) || colorImg(c);
    if (src) return { src, own: false, shownIn: c.photoFrom };
  }
  const own = colorImg(c);
  if (own) {
    const owner = photoOwner(st, own);
    return owner === c || !owner ? { src: own, own: true } : { src: own, own: false, shownIn: owner.name };
  }
  if (st.image && safeUrl(resolveImg(st.image))) {
    const src = safeUrl(resolveImg(st.image));
    const owner = photoOwner(st, src);
    return { src, own: false, shownIn: owner ? owner.name : null };
  }
  return { src: null, own: false };
}

function firstOwnIdx(st) {
  const i = st.colors.findIndex((_, k) => photoFor(st, k).own);
  return i < 0 ? 0 : i;
}
function cardIdx(st) {
  const v = state.cardColor[st.code];
  return v != null && st.colors[v] ? v : firstOwnIdx(st);
}

// Raya bajo la muestra elegida (como la tienda): del color de la muestra; si es casi blanco no se vería
// sobre el papel, así que va en gris. Estampados: color de tinta.
function swatchLine(c) {
  if (c.patternImage) return 'var(--color-ink)';
  const h = safeHex(c.hex).replace('#', '');
  const f = h.length <= 4 ? h.split('').slice(0, 3).map((x) => x + x).join('') : h.slice(0, 6);
  const [r, g, b] = [0, 2, 4].map((i) => parseInt(f.slice(i, i + 2), 16) / 255)
    .map((v) => (v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4));
  return 0.2126 * r + 0.7152 * g + 0.0722 * b > 0.6 ? 'var(--color-ink-muted)' : `#${f}`;
}

// Estilo de la muestra, ya escapado para el atributo style: patrón (URL validada) o color (hex validado).
function swatchStyle(c) {
  const pat = c.patternImage ? safeUrl(resolveImg(c.patternImage)) : '';
  return esc((pat
    ? `background-image:url("${pat}");background-size:cover;background-position:center`
    : `background:${safeHex(c.hex)}`) + `;--sw-line:${swatchLine(c)}`);
}

// Contenido de la foto de la tarjeta (foto / prestada / sin foto)
function cardPhotoHtml(st, idx) {
  if (!F('photoStates')) {
    return st.image
      ? `<img class="pc-img" src="${esc(safeUrl(resolveImg(st.image)))}" alt="${esc(st.name)}" loading="lazy" />`
      : `<div class="pc-noimg"><span class="pc-noimg-name">${esc(st.name)}</span><span class="pc-noimg-dots">${st.colors.slice(0, 6).map((c) => `<i style="${swatchStyle(c)}"></i>`).join('')}</span></div>`;
  }
  const c = st.colors[idx];
  const p = photoFor(st, idx);
  if (!p.src) {
    return `<div class="pc-noimg">
      <span class="pc-noimg-dot" style="${swatchStyle(c)}"></span>
      <span class="pc-noimg-name">${esc(st.name)}</span>
      <span class="pc-noimg-soon">${esc(t('photo_soon'))}</span>
    </div>`;
  }
  const note = !p.own && p.shownIn ? `<span class="pc-note">${esc(t('photo_in', { color: p.shownIn }))}</span>` : '';
  return `<img class="pc-img" src="${esc(p.src)}" alt="${esc(st.name)} · ${esc(c.name)}" loading="lazy" />${note}`;
}

function renderCatalog() {
  const root = byId('catalog');
  const styles = visibleStyles();
  root.innerHTML = '';
  byId('emptyState').hidden = styles.length > 0;
  const swatches = F('cardSwatches');
  const showPrice = showBrowsePrices();

  for (const st of styles) {
    const count = styleUnits(st);
    const idx = swatches ? cardIdx(st) : 0;
    const parts = showPrice ? stylePriceParts(st) : { main: '', sub: '' };
    const price = parts.main;
    const el = document.createElement('article');
    el.className = 'product-card';
    el.dataset.code = st.code;
    const baseLabel = `${st.name}, ${prettyType(st.product_type)}, ${colorsLabel(st.colors.length)}${price ? ', ' + price : ''}`;
    const label = baseLabel + (count ? ', ' + t('card_units', { n: count }) : '');
    const maxWide = 5;
    const maxNarrow = 3;
    const sw = swatches ? `
      <div class="pc-swatches" role="radiogroup" aria-label="${esc(t('swatches_of', { name: st.name }))}">
        ${st.colors.slice(0, maxWide).map((c, i) => `
          <button type="button" class="pc-sw${i >= maxNarrow ? ' pc-sw--wide' : ''}" role="radio" data-idx="${i}"
            aria-checked="${i === idx}" tabindex="${i === idx ? 0 : -1}" aria-label="${esc(c.name)}" title="${esc(c.name)}">
            <span class="pc-sw-dot" style="${swatchStyle(c)}"></span>
          </button>`).join('')}
        ${st.colors.length > maxNarrow ? `<button type="button" class="pc-more pc-more--narrow" data-more aria-label="${esc(t('more_colors', { n: st.colors.length - maxNarrow }))}">+${st.colors.length - maxNarrow}</button>` : ''}
        ${st.colors.length > maxWide ? `<button type="button" class="pc-more pc-more--wide" data-more aria-label="${esc(t('more_colors', { n: st.colors.length - maxWide }))}">+${st.colors.length - maxWide}</button>` : ''}
      </div>` : '';
    el.innerHTML = `
      <button type="button" class="pc-open" aria-label="${esc(label)}" data-label="${esc(baseLabel)}">
        <span class="pc-photo">
          <span class="pc-media">${cardPhotoHtml(st, idx)}</span>
          <span class="pc-badge u-tnum" data-count ${count ? '' : 'hidden'}>${count || ''}</span>
        </span>
        <span class="pc-meta">
          <span class="pc-name-row">
            <span class="pc-name">${esc(st.name)}</span>
            ${price ? `<span class="pc-price u-tnum">${esc(price)}${parts.sub ? `<span class="pc-price-sub">${esc(parts.sub)}</span>` : ''}</span>` : ''}
          </span>
          <span class="pc-type">${esc(prettyType(st.product_type))}${swatches ? '' : ' · ' + esc(colorsLabel(st.colors.length))}</span>
        </span>
      </button>
      ${sw}`;
    const open = el.querySelector('.pc-open');
    open.addEventListener('click', () => openProduct(st, swatches ? cardIdx(st) : 0, open));
    if (swatches) {
      el.querySelectorAll('.pc-sw').forEach((b) => b.addEventListener('click', () => setCardColor(el, st, parseInt(b.dataset.idx, 10))));
      el.querySelectorAll('[data-more]').forEach((b) => b.addEventListener('click', () => openProduct(st, cardIdx(st), open)));
      wireRadioGroup(el.querySelector('.pc-swatches'), (i) => setCardColor(el, st, i));
    }
    root.appendChild(el);
  }
}

// Navegación con flechas en un grupo de muestras (role=radiogroup, tabindex itinerante).
function wireRadioGroup(group, onSelect) {
  if (!group) return;
  group.addEventListener('keydown', (e) => {
    const step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
    if (!step && e.key !== 'Home' && e.key !== 'End') return;
    const radios = Array.from(group.querySelectorAll('[role="radio"]')).filter((r) => r.offsetParent !== null);
    const i = radios.indexOf(document.activeElement);
    if (i < 0 || !radios.length) return;
    e.preventDefault();
    let n = e.key === 'Home' ? 0 : e.key === 'End' ? radios.length - 1 : (i + step + radios.length) % radios.length;
    const target = radios[n];
    onSelect(parseInt(target.dataset.idx, 10));
    const fresh = group.querySelector(`[role="radio"][data-idx="${cssq(target.dataset.idx)}"]`);
    if (fresh) fresh.focus();
  });
}

function markRadios(group, idx) {
  if (!group) return;
  group.querySelectorAll('[role="radio"]').forEach((r) => {
    const on = parseInt(r.dataset.idx, 10) === idx;
    r.setAttribute('aria-checked', on ? 'true' : 'false');
    r.tabIndex = on ? 0 : -1;
  });
}

// La muestra de la tarjeta cambia la foto (fundido corto) y recuerda el color para la ficha.
function setCardColor(card, st, idx) {
  if (!st.colors[idx]) return;
  state.cardColor[st.code] = idx;
  markRadios(card.querySelector('.pc-swatches'), idx);
  const media = card.querySelector('.pc-media');
  if (!media) return;
  const p = F('photoStates') ? photoFor(st, idx) : { src: null };
  const img = media.querySelector('.pc-img');
  if (p.src && img) {
    const c = st.colors[idx];
    const swap = () => {
      img.src = p.src;
      img.alt = `${st.name} · ${c.name}`;
      img.classList.remove('is-fading');
      const old = media.querySelector('.pc-note');
      if (old) old.remove();
      if (!p.own && p.shownIn) media.insertAdjacentHTML('beforeend', `<span class="pc-note">${esc(t('photo_in', { color: p.shownIn }))}</span>`);
    };
    if (img.getAttribute('src') === p.src) { swap(); return; }
    img.classList.add('is-fading');
    const pre = new Image();
    pre.onload = swap;
    pre.onerror = swap;
    pre.src = p.src;
  } else {
    media.innerHTML = cardPhotoHtml(st, idx);
  }
}

function updateCardBadge(st) {
  const card = qs(`.product-card[data-code="${cssq(st.code)}"]`);
  if (!card) return;
  const b = card.querySelector('[data-count]');
  if (!b) return;
  const n = styleUnits(st);
  b.textContent = n || '';
  b.hidden = !n;
  const open = card.querySelector('.pc-open');
  if (open && open.dataset.label) open.setAttribute('aria-label', open.dataset.label + (n ? ', ' + t('card_units', { n }) : ''));
}

/* ----- ficha de producto (sheet) ----- */
let sheetRelease = null;

function openProduct(st, idx, trigger) {
  state.activeStyle = st;
  state.sheetReturn = trigger || document.activeElement;
  byId('psName').textContent = st.name;
  byId('psType').textContent = `${prettyType(st.product_type)} · ${colorsLabel(st.colors.length)}`;
  byId('psFabric').textContent = st.fabric || '';
  const close = byId('psClose');
  if (close) close.setAttribute('aria-label', t('close_sheet'));
  const colorsBox = byId('psColors');
  colorsBox.setAttribute('role', 'radiogroup');
  colorsBox.setAttribute('aria-label', t('sheet_colors'));
  colorsBox.innerHTML = st.colors.map((c, i) =>
    // estampados (bañadores): la imagen del PATRÓN como muestra; el resto = HEX
    `<button type="button" class="ps-swatch" role="radio" aria-checked="false" tabindex="-1" data-idx="${i}" aria-label="${esc(c.name)}" title="${esc(c.name)}">
      <span class="ps-swatch-dot" style="${swatchStyle(c)}"></span>
    </button>`).join('');
  colorsBox.querySelectorAll('.ps-swatch').forEach((b) => {
    b.addEventListener('click', () => selectColor(parseInt(b.dataset.idx, 10)));
  });
  if (!colorsBox.dataset.wired) { wireRadioGroup(colorsBox, (i) => selectColor(i)); colorsBox.dataset.wired = '1'; }
  const start = idx != null && st.colors[idx] ? idx : 0;
  selectColor(start);
  const sheet = byId('productSheet');
  sheet.hidden = false;
  const sc = byId('psScroll');
  if (sc) sc.scrollTop = 0;
  sheet.scrollTop = 0;
  lockScroll(true);
  if (sheetRelease) sheetRelease();
  sheetRelease = B2B ? B2B.trapFocus(sheet.querySelector('.sheet-box'), closeProduct)
    : (() => { document.addEventListener('keydown', psEsc); return () => document.removeEventListener('keydown', psEsc); })();
  byId('psClose').focus();
}

function psEsc(e) { if (e.key === 'Escape') closeProduct(); }

function closeProduct() {
  const sheet = byId('productSheet');
  if (sheet.hidden) return;
  sheet.hidden = true;
  lockScroll(false);
  if (sheetRelease) { sheetRelease(); sheetRelease = null; }
  const st = state.activeStyle;
  if (st) {
    updateCardBadge(st);
    // el color elegido en la ficha vuelve a la tarjeta
    if (F('cardSwatches')) {
      const card = qs(`.product-card[data-code="${cssq(st.code)}"]`);
      if (card && state.cardColor[st.code] !== state.activeColorIdx) setCardColor(card, st, state.activeColorIdx);
    }
  }
  let back = state.sheetReturn;
  if (st && (!back || back === document.body || !document.contains(back))) back = qs(`.product-card[data-code="${cssq(st.code)}"] .pc-open`);
  if (back && back.focus) back.focus();
}

/* ----- ficha: galería del color en vertical ----- */
// Scroll 100 % nativo (rueda, trackpad, dedo, teclado), como la ficha de la tienda: sin capturar la rueda ni
// animar por JS, para que el trackpad y la inercia vayan fluidos; al acabar las fotos el scroll sigue con la
// ficha. El indicador sigue a la foto visible con IntersectionObserver.
const gallery = { n: 0, io: null };
function galleryMarkIdx(i) {
  qsa('#psDots i').forEach((d, k) => d.classList.toggle('on', k === i));
}
function renderGallery(pics, st, c) {
  const tr = byId('psTrack');
  const dots = byId('psDots');
  if (!tr) return;
  if (gallery.io) { gallery.io.disconnect(); gallery.io = null; }
  gallery.n = pics.length;
  tr.innerHTML = pics.map((src, k) => `<img src="${esc(src)}" alt="${esc(`${st.name} · ${c.name}${pics.length > 1 ? ` (${k + 1}/${pics.length})` : ''}`)}"${k ? ' loading="lazy"' : ''} draggable="false" data-k="${k}" />`).join('');
  // vuelve a la primera foto también cuando la ficha aún está oculta (el scroll se aplica al mostrarse)
  tr.scrollTop = 0;
  requestAnimationFrame(() => { tr.scrollTop = 0; });
  const multi = pics.length > 1;
  tr.classList.toggle('is-multi', multi);
  tr.tabIndex = multi ? 0 : -1;
  if (multi) {
    tr.setAttribute('role', 'group');
    tr.setAttribute('aria-label', t('photos_of', { name: st.name, color: c.name }));
  } else {
    ['role', 'aria-label'].forEach((a) => tr.removeAttribute(a));
  }
  if (dots) {
    dots.innerHTML = multi ? pics.map(() => '<i></i>').join('') : '';
    dots.hidden = !multi;
  }
  galleryMarkIdx(0);
  if (multi && 'IntersectionObserver' in window) {
    gallery.io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) galleryMarkIdx(parseInt(e.target.dataset.k, 10)); });
    }, { root: tr, threshold: 0.55 });
    tr.querySelectorAll('img').forEach((img) => gallery.io.observe(img));
  }
}

function selectColor(idx) {
  const st = state.activeStyle;
  const c = st.colors[idx];
  if (!c) return;
  state.activeColorIdx = idx;
  if (F('cardSwatches')) state.cardColor[st.code] = idx;
  const noimg = byId('psNoImg');
  const note = byId('psPhotoNote');
  let p;
  if (F('photoStates')) p = photoFor(st, idx);
  else p = { src: imgOverride(st, c) || safeUrl(resolveImg(c.image || st.image)), own: true };
  // galería: todas las fotos del color si la foto es suya; si es prestada («Foto en X»), solo esa
  const ov = imgOverride(st, c);
  const pics = !p.src ? [] : (p.own && !ov ? colorImages(c) : [p.src]);
  if (p.src && pics[0] !== p.src) pics.unshift(p.src);
  renderGallery(pics, st, c);
  if (p.src) {
    noimg.hidden = true;
  } else {
    noimg.hidden = false;
    noimg.innerHTML = F('photoStates')
      ? `<span class="ps-noimg-circle" style="${swatchStyle(c)}"></span><span class="ps-noimg-name">${esc(st.name)}</span><span class="ps-noimg-soon">${esc(c.name)} · ${esc(t('photo_soon'))}</span>`
      : `<span class="ps-noimg-circle" style="background:${c.hex}"></span><span class="ps-noimg-name">${esc(st.name)}</span>`;
  }
  if (note) {
    const show = F('photoStates') && p.src && !p.own && p.shownIn;
    note.textContent = show ? t('photo_in', { color: p.shownIn }) : '';
    note.hidden = !show;
  }
  byId('psColorName').textContent = c.name;
  markRadios(byId('psColors'), idx);
  qsa('.ps-swatch').forEach((b, i) => b.classList.toggle('active', i === idx));
  renderSizes(c);
  renderCurve();
  renderSheetPrice();
}

// «€59 / ud · Mayorista» + «PVP recomendado en Francia: €165 (IVA incl.)». Sin sesión: invitación a entrar.
function renderSheetPrice() {
  const box = byId('psPrice');
  const st = state.activeStyle;
  if (!box || !st) return;
  const c = st.colors[state.activeColorIdx] || st.colors[0];
  if (!state.auth.session) {
    if (B2B) {
      box.innerHTML = `<button type="button" class="ps-price-login">${B2B.ICON.lock}<span>${esc(t('login_prices'))}</span></button>`;
      box.querySelector('button').addEventListener('click', () => { closeProduct(); doLogin(); });
      box.hidden = false;
    } else { box.hidden = true; }
    return;
  }
  if (!showBrowsePrices()) { box.hidden = true; box.innerHTML = ''; return; }
  const priced = c.sizes.map((sz) => skuPrice(sz.sku)).filter(Boolean);
  if (!priced.length) {
    box.innerHTML = `<p class="ps-price-none">${esc(t('no_price'))}</p>`;
    box.hidden = false;
    return;
  }
  const minP = priced.reduce((a, p) => (p.w < a.w ? p : a), priced[0]);
  const min = minP.w;
  const max = Math.max(...priced.map((p) => p.w));
  const loc = localPrice(minP);
  const eur = fmtP(min, minP.cur);
  const main = loc ? fmtP(loc.n, loc.cur) : eur;
  const mainTxt = max > min + 0.004 ? t('from_price', { price: main }) : main;
  const eurHtml = loc ? `<p class="ps-price-eur"><span class="u-tnum">${esc(eur)}</span> · ${esc(t('billed_in', { cur: minP.cur }))}</p>` : '';
  let rrpHtml = '';
  if (F('showRrp')) {
    rrpHtml = rrpCountries().map((cc) => {
      const m = state.auth.rrp.get(cc);
      const r = m && c.sizes.map((sz) => m.get(sz.sku)).find(Boolean);
      if (!r) return `<p class="ps-rrp">${esc(t('rrp_in', { country: B2B.countryName(cc) }))}: ${esc(t('rrp_not_configured'))}</p>`;
      const val = fmtP(r.amount, r.cur);
      if (!val) return '';
      return `<p class="ps-rrp">${esc(t('rrp_in', { country: B2B.countryName(cc) }))}: <strong class="u-tnum">${esc(val)}</strong> <span>(${esc(r.vat ? t('vat_incl') : t('vat_excl'))})</span></p>`;
    }).join('');
    if (!rrpCountries().length && state.auth.storeIds[0]) rrpHtml = `<p class="ps-rrp">${esc(t('rrp_not_configured'))}</p>`;
  }
  box.innerHTML = `
    <p class="ps-price-main"><strong class="u-tnum">${esc(mainTxt)}</strong> <span>/ ${esc(t('per_unit'))} · ${esc(t(state.auth.priceLabel || 'wholesale'))}</span></p>
    ${eurHtml}
    ${rrpHtml}`;
  box.hidden = false;
}

/* ----- curva de tallas por familia (editable, se guarda en este navegador) ----- */
const sizeSig = (c) => c.sizes.map((s) => s.size).join(',');

// Curva aplicable a un color: la editada para su familia de tallas, la por defecto (D3) o ninguna.
function curveFor(c) {
  if (!F('sizeCurves')) return state.curve;
  const sig = sizeSig(c);
  const defs = (state.config.order && state.config.order.sizeCurves) || {};
  return state.curveOverrides[sig] || defs[sig] || null;
}
function editableCurve(c) {
  if (!F('sizeCurves')) return state.curve;
  const sig = sizeSig(c);
  if (!state.curveOverrides[sig]) state.curveOverrides[sig] = Object.assign({}, curveFor(c) || {});
  return state.curveOverrides[sig];
}
function curveUnits(c) {
  const cv = curveFor(c) || {};
  return c.sizes.reduce((n, sz) => n + (cv[sz.size] || 0), 0);
}

function renderCurve() {
  const box = byId('psCurve');
  const c = state.activeStyle.colors[state.activeColorIdx];
  const cv = curveFor(c);
  // tallas únicas, S/M, M/L y accesorios: sin curva, cantidades a mano
  if (!cv) { box.hidden = true; box.innerHTML = ''; return; }
  box.hidden = false;
  box.innerHTML = `
    <div class="ps-curve-head">
      <span class="ps-curve-title">${t('curve_title')}</span>
      <button type="button" class="ps-curve-toggle" id="psEdit" aria-expanded="false" aria-controls="psEditor">${t('curve_edit')}</button>
    </div>
    <button type="button" class="btn-curve" id="psApply">${esc(curveButtonLabel(c))}</button>
    <div class="curve-editor" id="psEditor">
      <p class="curve-editor-hint">${t('curve_hint')}</p>
      <div class="curve-cells">
        ${c.sizes.map((sz) => {
          const v = cv[sz.size] != null ? cv[sz.size] : 0;
          return `<div class="curve-cell">
            <span class="size-label">${esc(sz.size)}</span>
            <div class="stepper">
              <button type="button" data-cv="dec" data-size="${esc(sz.size)}" aria-label="${esc(t('curve_less', { size: sz.size }))}">−</button>
              <input type="text" inputmode="numeric" pattern="[0-9]*" value="${esc(v)}" data-size="${esc(sz.size)}" aria-label="${esc(t('curve_size', { size: sz.size }))}" />
              <button type="button" data-cv="inc" data-size="${esc(sz.size)}" aria-label="${esc(t('curve_more', { size: sz.size }))}">+</button>
            </div>
          </div>`;
        }).join('')}
      </div>
      <button type="button" class="btn-curve-save" id="psCurveSave">${t('curve_save')}</button>
    </div>`;
  byId('psApply').addEventListener('click', applyCurveToColor);
  byId('psEdit').addEventListener('click', () => {
    const ed = byId('psEditor');
    ed.classList.toggle('open');
    const open = ed.classList.contains('open');
    byId('psEdit').textContent = open ? t('close') : t('curve_edit');
    byId('psEdit').setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  byId('psCurveSave').addEventListener('click', () => {
    saveCurve();
    const ed = byId('psEditor');
    ed.classList.remove('open');
    byId('psEdit').textContent = t('curve_edit');
    byId('psEdit').setAttribute('aria-expanded', 'false');
    refreshCurveLabel();
  });
  box.querySelectorAll('.curve-cell [data-cv]').forEach((b) => {
    b.addEventListener('click', () => bumpCurve(b.dataset.size, b.dataset.cv === 'inc' ? 1 : -1));
  });
  box.querySelectorAll('.curve-cell input').forEach((inp) => {
    inp.addEventListener('input', () => {
      editableCurve(c)[inp.dataset.size] = Math.max(0, parseInt(inp.value || '0', 10) || 0);
      saveCurve(); refreshCurveLabel();
    });
  });
}

// «Pedir curva M1 · L2 · XL2 · XXL1 (6 uds)»
function curveButtonLabel(c) {
  if (!F('sizeCurves')) return `${t('curve_order')} · ${curveLabel(c)}`;
  return `${t('curve_order')} ${curveLabel(c)} (${t('curve_units', { n: curveUnits(c) })})`;
}

function curveLabel(c) {
  const cv = curveFor(c) || {};
  if (!F('sizeCurves')) return c.sizes.map((sz) => (cv[sz.size] != null ? cv[sz.size] : 0)).join(' · ');
  return c.sizes.filter((sz) => cv[sz.size] > 0).map((sz) => `${sz.size}${cv[sz.size]}`).join(' · ');
}

function refreshCurveLabel() {
  const btn = byId('psApply');
  if (btn && state.activeStyle) btn.textContent = curveButtonLabel(state.activeStyle.colors[state.activeColorIdx]);
}

function bumpCurve(size, delta) {
  const c = state.activeStyle.colors[state.activeColorIdx];
  const cv = editableCurve(c);
  cv[size] = Math.max(0, (cv[size] || 0) + delta);
  saveCurve();
  renderCurve();
  byId('psEditor').classList.add('open');
  byId('psEdit').textContent = t('close');
  byId('psEdit').setAttribute('aria-expanded', 'true');
}

function applyCurveToColor() {
  const c = state.activeStyle.colors[state.activeColorIdx];
  const cv = curveFor(c) || {};
  c.sizes.forEach((sz) => {
    const q = cv[sz.size];
    if (q != null && q > 0) setQty(sz.sku, (state.qty[sz.sku] || 0) + q);
  });
  renderSizes(c);
}

function saveCurve() {
  try {
    if (F('sizeCurves')) localStorage.setItem(CURVE_KEY, JSON.stringify(state.curveOverrides));
    else localStorage.setItem('ses_curve_v1', JSON.stringify(state.curve));
  } catch (_) { /* */ }
}

function renderSizes(c) {
  const st = state.activeStyle;
  const box = byId('psSizes');
  box.className = 'ps-sizes ps-sizes--n' + c.sizes.length;
  box.innerHTML = c.sizes.map((sz) => {
    const qty = state.qty[sz.sku] || 0;
    const ctx = { name: st.name, color: c.name, size: sz.size };
    return `
      <div class="size-cell ${qty ? 'has-qty' : ''}" data-sku="${esc(sz.sku)}">
        <span class="size-label">${esc(sz.size)}</span>
        <div class="stepper">
          <button type="button" data-act="dec" aria-label="${esc(t('qty_less', ctx))}">−</button>
          <input type="text" inputmode="numeric" pattern="[0-9]*" value="${esc(qty || '')}" placeholder="0" data-sku="${esc(sz.sku)}" aria-label="${esc(t('qty_units', ctx))}" />
          <button type="button" data-act="inc" aria-label="${esc(t('qty_more', ctx))}">+</button>
        </div>
      </div>`;
  }).join('');
  box.querySelectorAll('.size-cell').forEach((cell) => {
    const input = cell.querySelector('input');
    const sku = cell.dataset.sku;
    cell.querySelector('[data-act="inc"]').addEventListener('click', () => bumpSheet(sku, +1, input, cell));
    cell.querySelector('[data-act="dec"]').addEventListener('click', () => bumpSheet(sku, -1, input, cell));
    input.addEventListener('input', () => {
      const v = Math.max(0, parseInt(input.value || '0', 10) || 0);
      setQty(sku, v); cell.classList.toggle('has-qty', v > 0); updateSheetCount();
      toggleClearBtn(c);
    });
  });
  updateSheetCount();
  toggleClearBtn(c);
}

// Muestra "Vaciar" solo si el color actual tiene alguna unidad
function toggleClearBtn(c) {
  const btn = byId('psClear');
  if (!btn) return;
  const has = c.sizes.some((sz) => (state.qty[sz.sku] || 0) > 0);
  btn.hidden = !has;
}

// Quita de golpe todas las unidades del color que se está viendo
function clearColorSizes() {
  if (!state.activeStyle) return;
  const c = state.activeStyle.colors[state.activeColorIdx];
  c.sizes.forEach((sz) => setQty(sz.sku, 0));
  renderSizes(c);
}

function bumpSheet(sku, delta, input, cell) {
  const v = Math.max(0, (state.qty[sku] || 0) + delta);
  setQty(sku, v);
  input.value = v || '';
  cell.classList.toggle('has-qty', v > 0);
  updateSheetCount();
  if (state.activeStyle) toggleClearBtn(state.activeStyle.colors[state.activeColorIdx]);
}

function updateSheetCount() {
  const st = state.activeStyle;
  if (!st) return;
  const n = styleUnits(st);
  let txt = `${n} ${unitsWord(n)}`;
  if (n && showBrowsePrices()) {
    const amt = dualAmount(orderAmount(st));
    if (amt) txt += ` · ${amt}`;
  }
  byId('psCount').textContent = txt;
}

function setQty(sku, v) {
  if (v > 0) state.qty[sku] = v; else delete state.qty[sku];
  saveDraft();
  updateSummary();
}

function styleUnits(st) {
  let n = 0;
  for (const c of st.colors) for (const sz of c.sizes) n += state.qty[sz.sku] || 0;
  return n;
}

/* ---------- resumen ---------- */
// Una «línea» es un estilo en un color (como en la hoja de pedido y el CRM); las tallas son unidades.
function totals() {
  let units = 0;
  const rows = new Set();
  for (const sku in state.qty) {
    const q = state.qty[sku];
    if (!q) continue;
    units += q;
    const m = state.skuMeta[sku];
    rows.add(m ? m.styleCode + '|' + m.color : sku);
  }
  return { units, lines: rows.size };
}
const unitsWord = (n) => (n === 1 ? t('unit_one') : t('units'));
const linesText = (n) => t(n === 1 ? 'line_one' : 'line_many', { n });

function updateSummary() {
  const { units, lines } = totals();
  byId('summaryUnits').textContent = units;
  byId('summaryUnitsLbl').textContent = unitsWord(units);
  byId('summaryLines').textContent = linesText(lines);
  const bar = byId('summaryBar');
  if (bar) bar.classList.toggle('is-empty', units === 0);
  const amountEl = byId('summaryAmount');
  if (amountEl) {
    const a = units && showBrowsePrices() ? orderAmount() : null;
    const txt = a ? dualAmount(a) : '';
    amountEl.textContent = txt;
    amountEl.hidden = !txt;
  }
  updateActionButtons();
  const reC = byId('summaryReopenCount');
  if (reC) reC.textContent = units;
  const reL = byId('summaryReopenLbl');
  if (reL) reL.textContent = unitsWord(units);
  showSummaryBar(); // cualquier cambio revela la barra y reprograma el auto-ocultado
}

/* ---------- barra de resumen auto-ocultable (móvil) ---------- */
let summaryHideTimer = null;
const SUMMARY_HIDE_MS = 5000;
function summaryAutoHideEnabled() {
  return !!(window.matchMedia && window.matchMedia('(max-width: 560px)').matches);
}
function showSummaryBar(reschedule) {
  const bar = byId('summaryBar');
  if (!bar) return;
  bar.classList.remove('is-hidden');
  const re = byId('summaryReopen');
  if (re) re.hidden = true;
  if (summaryHideTimer) { clearTimeout(summaryHideTimer); summaryHideTimer = null; }
  if (reschedule !== false && summaryAutoHideEnabled()) {
    summaryHideTimer = setTimeout(hideSummaryBar, SUMMARY_HIDE_MS);
  }
}
function hideSummaryBar() {
  if (!summaryAutoHideEnabled()) return;
  const bar = byId('summaryBar');
  if (!bar) return;
  bar.classList.add('is-hidden');
  const re = byId('summaryReopen');
  if (re) {
    const c = byId('summaryReopenCount');
    if (c) c.textContent = totals().units;
    re.hidden = false;
  }
}

/* ---------- borrador local ---------- */
function basketKey() {
  const a = state.auth;
  const uid = a.session && a.session.user && a.session.user.id;
  return uid && a.companyId ? `${STORE_KEY}:${uid}:${a.companyId}:${season()}` : null;
}

function saveDraft() {
  const key = basketKey();
  if (!key) return;
  try { localStorage.setItem(key, JSON.stringify({ qty: state.qty, ts: Date.now() })); }
  catch (e) { /* almacenamiento lleno o bloqueado */ }
}

// Carga la cesta de la empresa elegida (o la vacía si no hay).
function restoreDraft() {
  state.qty = {};
  const key = basketKey();
  if (!key) return;
  try {
    const d = JSON.parse(localStorage.getItem(key) || 'null');
    const qty = (d && d.qty) || {};
    Object.keys(qty).forEach((sku) => {
      const q = parseInt(qty[sku], 10) || 0;
      if (q > 0 && q <= 9999 && state.skuMeta[sku]) state.qty[sku] = q;
    });
  } catch (e) { /* ignorar */ }
}

async function resetOrder() {
  const ok = B2B
    ? await B2B.confirmDialog({ title: t('reset_title'), text: t('reset_text'), okLabel: t('reset_ok'), cancelLabel: t('cancel'), danger: true, root: APP_ROOT })
    : window.confirm(t('reset_title') + ' ' + t('reset_text'));
  if (!ok) return;
  clearOrder();
  showToast(t('new_ready'), 'ok');
}

function clearOrder() {
  state.qty = {};
  if (state.auth.session) { state.auth.po = ''; state.auth.comment = ''; syncBuyerFromCompany(); }
  else state.buyer = {};
  state.termsAccepted = null; // cada pedido nuevo requiere aceptación fresca
  const key = basketKey();
  if (key) { try { localStorage.removeItem(key); } catch (_) { /* */ } }
  qsa('[data-key]').forEach((el) => (el.value = ''));
  renderBuyer();
  renderCatalog();
  updateSummary();
}

/* ---------- construir líneas del pedido ---------- */
function buildOrderLines() {
  const lines = [];
  for (const sku in state.qty) {
    const m = state.skuMeta[sku];
    if (!m) continue;
    lines.push({ sku, units: state.qty[sku], ...m });
  }
  // ordenar por tipo, estilo, color, talla
  lines.sort((a, b) =>
    a.type.localeCompare(b.type) || a.styleName.localeCompare(b.styleName) ||
    a.color.localeCompare(b.color) || 0);
  return lines;
}

/* Agrupa el pedido por (estilo, color) en filas tipo hoja del CRM:
   { code, name, color, composition, image, sku, sizes:{talla:uds}, total } */
function buildSheetLines() {
  const map = {};
  const order = [];
  for (const sku in state.qty) {
    const q = state.qty[sku];
    if (!q) continue;
    const m = state.skuMeta[sku];
    if (!m) continue;
    const key = m.styleCode + '|' + m.color;
    let row = map[key];
    if (!row) {
      const st = state.catalog.find((s) => s.code === m.styleCode);
      const col = st && st.colors.find((c) => c.name === m.color);
      row = map[key] = {
        code: skuBase(sku, m.size),
        styleCode: m.styleCode,
        name: m.styleName,
        color: m.color,
        composition: (st && st.fabric) || '',
        image: resolveImg((col && col.image) || (st && st.image) || ''),
        sizes: {},
        total: 0,
        _type: m.type,
      };
      order.push(key);
    }
    row.sizes[m.size] = (row.sizes[m.size] || 0) + q;
    row.total += q;
  }
  // mismo orden del catálogo (que ya viene en orden dossier)
  const idx = {};
  state.catalog.forEach((s, i) => { idx[s.code] = i; });
  return order.map((k) => map[k]).sort((a, b) =>
    (idx[a.code] ?? 0) - (idx[b.code] ?? 0) || a.name.localeCompare(b.name) ||
    a.color.localeCompare(b.color));
}

// Quita el sufijo de talla del SKU para mostrar la referencia base (como el CRM)
function skuBase(sku, size) {
  let base = sku;
  if (size && sku.toUpperCase().endsWith(size.toUpperCase())) {
    base = sku.slice(0, sku.length - size.length);
  }
  return base.replace(/[\s\-_]+$/, ''); // quita separador colgante (ej. "XESC-CAPV-")
}

// Carga una imagen remota como dataURL (para incrustarla en el PDF). Cachea.
function imgToDataUrl(url) {
  if (!url) return Promise.resolve(null);
  if (state.imgCache[url]) return Promise.resolve(state.imgCache[url]);
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      try {
        const max = 240; // suficiente para 20mm en el PDF, mantiene el email ligero
        const scale = Math.min(1, max / Math.max(img.width, img.height));
        const w = Math.round(img.width * scale);
        const h = Math.round(img.height * scale);
        const cv = document.createElement('canvas');
        cv.width = w; cv.height = h;
        cv.getContext('2d').drawImage(img, 0, 0, w, h);
        const data = cv.toDataURL('image/jpeg', 0.82);
        state.imgCache[url] = data;
        resolve(data);
      } catch (_) { resolve(null); }
    };
    img.onerror = () => resolve(null);
    img.src = url;
  });
}

// Precarga las fotos de las líneas del pedido antes de generar el PDF
async function preloadSheetImages(rows) {
  const urls = [...new Set(rows.map((r) => r.image).filter(Boolean))];
  await Promise.all(urls.map(imgToDataUrl));
}

/* Modelo común del documento — alimenta la vista web y el PDF por igual */
/* formatea un importe en la moneda del pedido (enteros, estilo es-ES) */
function fmtMoney(n, currency) {
  if (n == null) return '';
  const sym = (!currency || currency === 'EUR') ? '€' : currency;
  const whole = Math.abs(n - Math.round(n)) < 0.005;
  const txt = Number(n).toLocaleString('es-ES', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2, useGrouping: 'always' });
  // es-ES no agrupa los números de 4 cifras: «1.970,25 €», no «1970,25 €»
  return txt.replace(/^(-?)(\d+)/, (m, s0, int) => s0 + int.replace(/\B(?=(\d{3})+(?!\d))/g, '.')) + ' ' + sym;
}

function sheetModel() {
  const b = state.config.brand;
  const iss = b.issuer || {};
  const by = state.buyer;
  const now = new Date();
  const order = state.config.order || {};
  // precios solo con sesión: los de la cuenta, cargados de Supabase (nunca del asset público)
  const showPrices = pricesOn();
  let currency = order.currency || 'EUR';
  const rows = buildSheetLines();
  rows.forEach((r) => {
    let amount = 0, unit = null, uniform = true, missing = false;
    for (const size in r.sizes) {
      const sku = skuOf(r.styleCode, r.color, size);
      const p = sku ? skuPrice(sku) : null;
      if (!p) { missing = true; continue; }
      currency = p.cur || currency;
      amount += p.w * r.sizes[size];
      if (unit == null) unit = p.w; else if (Math.abs(unit - p.w) > 0.004) uniform = false;
    }
    r.missing = showPrices && missing;
    r.wholesale = showPrices && unit != null && uniform ? unit : null;
    r.amount = showPrices && !missing ? Math.round(amount * 100) / 100 : null;
  });
  const totalUnits = rows.reduce((s, r) => s + r.total, 0);
  const totalAmount = Math.round(rows.reduce((s, r) => s + (r.amount || 0), 0) * 100) / 100;
  const missingRows = rows.filter((r) => r.missing);
  // BILL TO a partir del comprador
  const billLines = [];
  if (by.country) billLines.push(by.country);
  if (by.vat_id) billLines.push('VAT ' + by.vat_id);
  return {
    issuer: iss,
    doc: {
      kindEs: 'HOJA DE PEDIDO', kindEn: 'ORDER FORM',
      number: b.season || '',
      date: now.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' }),
    },
    billTo: {
      name: by.company || '-',
      lines: billLines,
      attn: by.contact || '',
      email: by.email || '',
    },
    terms: [
      { es: 'TEMPORADA', en: 'SEASON', val: b.season || '-' },
      { es: 'PRECIOS', en: 'PRICE LIST', val: showPrices ? ('Wholesale · ' + currency) : '-' },
      { es: 'FECHA', en: 'DATE', val: now.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' }) },
    ],
    rows,
    totalUnits,
    totalLines: rows.length,
    showPrices,
    totalAmount,
    missingRows,
    currency,
    notes: [by.po ? 'PO: ' + by.po : '', by.notes || ''].filter(Boolean).join(' · '),
  };
}

/* ---------- modal revisar ---------- */
let reviewReturn = null;
function openReview() {
  reviewReturn = document.activeElement;
  renderReview();
  byId('reviewModal').hidden = false;
  lockScroll(true);
  document.addEventListener('keydown', escClose);
  const close = byId('btnCloseReview');
  if (close) close.focus();
  // precarga fotos en segundo plano → al re-render quedan cacheadas (y el PDF es instantáneo)
  const rows = buildSheetLines();
  if (rows.length) {
    preloadSheetImages(rows).then(() => {
      if (!byId('reviewModal').hidden) renderReview();
    });
  }
}

// SKU de una (estilo, color, talla) concretos — para editar celdas de la rejilla
function skuOf(code, color, size) {
  const st = state.catalog.find((s) => s.code === code);
  if (!st) return null;
  const col = st.colors.find((c) => c.name === color);
  if (!col) return null;
  const sz = col.sizes.find((z) => z.size === size);
  return sz ? sz.sku : null;
}

const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) =>
  ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
// Datos del catálogo y del CRM que van a atributos, CSS o selectores: siempre validados o escapados.
// bloqueo de scroll compartido con los diálogos del núcleo (contador: no se pisan entre sí)
const lockScroll = (on) => { if (B2B) B2B.lockScroll(on); else document.body.style.overflow = on ? 'hidden' : ''; };
const safeHex = (v) => (B2B ? B2B.safeHex(v) : '#cccccc');
const safeUrl = (v, o) => (B2B ? B2B.safeUrl(v, o) : '');
const cssq = (v) => (window.CSS && CSS.escape ? CSS.escape(String(v)) : String(v).replace(/["\\\]\[]/g, '\\$&'));

function renderReview() {
  const body = byId('reviewBody');
  const m = sheetModel();
  if (!m.rows.length) {
    body.innerHTML = `<p class="review-empty">${t('review_empty')}</p>`;
    return;
  }
  const iss = m.issuer;
  const contact = [];
  if (iss.email) contact.push('E: ' + iss.email);
  if (iss.website) contact.push('W: ' + iss.website);

  const header = `
    <div class="os-head">
      ${safeUrl(state.logoDataUrl, { allowData: true }) ? `<img class="os-logo" src="${esc(safeUrl(state.logoDataUrl, { allowData: true }))}" alt="SES Palma" />` : ''}
      <div class="os-head-cols">
        <div class="os-issuer">
          <strong>${esc(iss.name || 'SES Palma')}</strong>
          ${iss.legalName ? `<span>${esc(iss.legalName)}</span>` : ''}
          ${iss.taxId ? `<span>CIF/NIF ${esc(iss.taxId)}</span>` : ''}
          ${(iss.address || []).map((l) => `<span>${esc(l)}</span>`).join('')}
          ${contact.length ? `<span>${esc(contact.join('  ·  '))}</span>` : ''}
        </div>
        <div class="os-doc">
          <div class="os-doc-kind">${esc(m.doc.kindEs)} · ${esc(m.doc.kindEn)}</div>
          <div class="os-doc-num">${esc(m.doc.number)}</div>
          <div class="os-doc-date">Fecha · Date ${esc(m.doc.date)}</div>
        </div>
      </div>
    </div>`;

  const parties = `
    <div class="os-parties">
      <div class="os-party">
        <div class="os-label">FACTURAR A · BILL TO</div>
        <strong>${esc(m.billTo.name)}</strong>
        ${m.billTo.lines.map((l) => `<span>${esc(l)}</span>`).join('')}
        ${m.billTo.attn ? `<span class="os-attn"><b>ATTN</b> · ATTN: ${esc(m.billTo.attn)}</span>` : ''}
        ${m.billTo.email ? `<span>E: ${esc(m.billTo.email)}</span>` : ''}
      </div>
      <div class="os-party">
        <div class="os-label">NOTAS · NOTES</div>
        <span class="os-notes">${m.notes ? esc(m.notes) : '-'}</span>
      </div>
    </div>`;

  const terms = `
    <div class="os-terms">
      ${m.terms.map((t) => `
        <div class="os-term">
          <div class="os-label">${esc(t.es)} · ${esc(t.en)}</div>
          <div class="os-term-val">${esc(t.val)}</div>
        </div>`).join('')}
    </div>`;

  const headCells = SIZE_COLS.map((s) => `<th class="os-sz">${s}</th>`).join('');
  const rowsHtml = m.rows.map((r) => {
    const cached = r.image ? safeUrl(state.imgCache[r.image], { allowData: true }) : '';
    const remote = r.image ? safeUrl(r.image) : '';
    const photo = cached ? `<img src="${esc(cached)}" alt="" />`
      : (remote ? `<img src="${esc(remote)}" alt="" loading="lazy" />` : '<span class="os-noimg"></span>');
    const sizeCells = SIZE_COLS.map((sz) => {
      const sku = skuOf(r.styleCode, r.color, sz);
      const q = sku ? (state.qty[sku] || 0) : 0;
      if (!sku) return '<td class="os-sz os-sz-na"></td>';
      return `<td class="os-sz${q ? ' filled' : ''}">
        <input type="text" inputmode="numeric" pattern="[0-9]*" value="${q || ''}"
          data-sku="${esc(sku)}" aria-label="${esc(t('qty_units', { name: r.name, color: r.color, size: sz }))}" />
      </td>`;
    }).join('');
    return `
      <tr>
        <td class="os-photo">${photo}</td>
        <td class="os-item">
          <strong>${esc(r.code)}</strong>
          <span>${esc(r.name)}</span>
          <span>${esc(r.color)}</span>
          ${r.composition ? `<span class="os-comp">${esc(r.composition)}</span>` : ''}
        </td>
        ${sizeCells}
        <td class="os-total">${esc(r.total)}</td>
        <td class="os-price">${m.showPrices && r.wholesale != null ? esc(fmtP(r.wholesale, m.currency)) : (r.missing ? `<span class="os-missing">${esc(t('no_price'))}</span>` : '')}</td>
        <td class="os-amount">${m.showPrices && r.amount != null ? esc(fmtP(r.amount, m.currency)) : ''}</td>
      </tr>`;
  }).join('');

  const grid = `
    <div class="os-grid-scroll">
      <table class="os-grid">
        <thead>
          <tr>
            <th class="os-photo">FOTO · IMG</th>
            <th class="os-item">ARTÍCULO · ITEM</th>
            ${headCells}
            <th class="os-total">UDS · QTY</th>
            <th class="os-price">PRECIO · PRICE</th>
            <th class="os-amount">IMPORTE · TOTAL</th>
          </tr>
        </thead>
        <tbody>${rowsHtml}</tbody>
        <tfoot>
          <tr>
            <td class="os-foot-label" colspan="${2 + SIZE_COLS.length}">${m.totalLines === 1 ? '1 línea · 1 line' : (m.totalLines === 1 ? '1 línea · 1 line' : `${m.totalLines} líneas · ${m.totalLines} lines`)}</td>
            <td class="os-total">${m.totalUnits}</td>
            <td class="os-price"></td>
            <td class="os-amount">${m.showPrices ? esc(fmtP(m.totalAmount, m.currency)) : ''}</td>
          </tr>
        </tfoot>
      </table>
    </div>`;

  const vatNote = m.showPrices
    ? `<p class="os-vat">Precios wholesale sin IVA · Wholesale prices exclude VAT. El IVA se aplica en la factura final según el país y el régimen fiscal del comprador.</p>`
    : '';
  const missingNote = m.missingRows.length
    ? `<div class="os-warn" role="alert"><strong>${esc(t('missing_prices'))}</strong><ul>${m.missingRows.map((r) => `<li>${esc(r.name)} · ${esc(r.color)}</li>`).join('')}</ul></div>`
    : '';
  body.innerHTML = `<div class="os-sheet">${missingNote}${header}${parties}${terms}${grid}${vatNote}</div>`;

  body.querySelectorAll('.os-grid input').forEach((input) => {
    const sku = input.dataset.sku;
    input.addEventListener('input', () => {
      const v = Math.max(0, parseInt(input.value || '0', 10) || 0);
      setQty(sku, v);
      const td = input.closest('td');
      if (td) td.classList.toggle('filled', v > 0);
      updateReviewTotals();
    });
    input.addEventListener('blur', () => { if (parseInt(input.value, 10) === 0) input.value = ''; });
  });
}

// Recalcula los totales (TOTAL por fila + pie) sin re-renderizar toda la rejilla
function updateReviewTotals() {
  const body = byId('reviewBody');
  let grand = 0;
  body.querySelectorAll('.os-grid tbody tr').forEach((tr) => {
    let rowSum = 0;
    tr.querySelectorAll('input[data-sku]').forEach((inp) => {
      rowSum += Math.max(0, parseInt(inp.value || '0', 10) || 0);
    });
    const tot = tr.querySelector('.os-total');
    if (tot) tot.textContent = rowSum;
    grand += rowSum;
  });
  const footTot = body.querySelector('tfoot .os-total');
  if (footTot) footTot.textContent = grand;
}

function escClose(e) { if (e.key === 'Escape') closeReview(); }

function closeReview() {
  const m = byId('reviewModal');
  if (m.hidden) return;
  m.hidden = true;
  lockScroll(false);
  document.removeEventListener('keydown', escClose);
  refreshAllBadges();
  // el foco vuelve a donde estaba (el botón de la barra)
  const back = reviewReturn && document.contains(reviewReturn) && !reviewReturn.disabled ? reviewReturn : byId('btnReview');
  reviewReturn = null;
  if (back && back.focus && back.offsetParent !== null) back.focus({ preventScroll: true });
}

function refreshAllBadges() {
  state.catalog.forEach(updateCardBadge);
}

/* abrir un estilo via ?open=CODE (deep-link / QR a un estilo) */
function openDeepLink() {
  const code = new URLSearchParams(location.search).get('open');
  if (!code) return;
  const st = state.catalog.find((s) => s.code === code.toUpperCase());
  if (st) openProduct(st, F('cardSwatches') ? cardIdx(st) : 0);
}

/* ---------- PDF — réplica exacta de la hoja de pedido del CRM ---------- */
async function buildPdfDoc() {
  const b = state.config.brand;
  const m = sheetModel();
  await preloadSheetImages(m.rows);
  const iss = m.issuer;
  const company = state.buyer.company || 'Pedido';

  // Cabecera: logo centrado + emisor (izq) / doc (der)
  const issuerStack = [{ text: iss.name || 'SES Palma', bold: true, fontSize: 11, color: DOC.ink }];
  if (iss.legalName) issuerStack.push({ text: iss.legalName, fontSize: 8, color: DOC.grey });
  if (iss.taxId) issuerStack.push({ text: 'CIF/NIF ' + iss.taxId, fontSize: 8, color: DOC.grey });
  (iss.address || []).forEach((l) => issuerStack.push({ text: l, fontSize: 8, color: DOC.grey }));
  const contact = [];
  if (iss.email) contact.push('E: ' + iss.email);
  if (iss.website) contact.push('W: ' + iss.website);
  if (contact.length) issuerStack.push({ text: contact.join('  ·  '), fontSize: 8, color: DOC.grey });

  const docStack = [
    { text: `${m.doc.kindEs} · ${m.doc.kindEn}`, alignment: 'right', fontSize: 8, color: DOC.taupe },
    { text: m.doc.number, alignment: 'right', fontSize: 22, bold: true, color: DOC.ink, margin: [0, 2, 0, 0] },
    { text: `Fecha · Date ${m.doc.date}`, alignment: 'right', fontSize: 8, color: DOC.grey, margin: [0, 4, 0, 0] },
  ];

  const header = [];
  if (state.logoDataUrl) {
    header.push({ image: state.logoDataUrl, width: 56, alignment: 'center', margin: [0, 0, 0, 14] });
  }
  header.push({
    columns: [
      { width: '*', stack: issuerStack },
      { width: '*', stack: docStack },
    ],
  });

  // Tarjeta FACTURAR A / NOTAS (fondo crema)
  const billStack = [
    { text: 'FACTURAR A · BILL TO', fontSize: 8, color: DOC.taupe, margin: [0, 0, 0, 3] },
    { text: m.billTo.name, bold: true, fontSize: 10, color: DOC.ink },
  ];
  m.billTo.lines.forEach((l) => billStack.push({ text: l, fontSize: 9, color: DOC.grey }));
  if (m.billTo.attn) billStack.push({ text: 'ATTN · ATTN: ' + m.billTo.attn, fontSize: 9, color: DOC.grey, margin: [0, 3, 0, 0] });
  if (m.billTo.email) billStack.push({ text: 'E: ' + m.billTo.email, fontSize: 9, color: DOC.grey });
  const notesStack = [
    { text: 'NOTAS · NOTES', fontSize: 8, color: DOC.taupe, margin: [0, 0, 0, 3] },
    { text: m.notes || '', fontSize: 9, color: DOC.grey },
  ];
  const partiesTable = {
    table: { widths: ['*', '*'], body: [[{ stack: billStack }, { stack: notesStack }]] },
    layout: {
      fillColor: () => DOC.cream,
      hLineWidth: () => 0, vLineWidth: () => 0,
      paddingLeft: () => 12, paddingRight: () => 12, paddingTop: () => 10, paddingBottom: () => 10,
    },
    margin: [0, 14, 0, 0],
  };

  // Barra de términos (5 celdas con separadores verticales)
  const termCells = m.terms.map((t) => ({
    stack: [
      { text: `${t.es} · ${t.en}`, fontSize: 7, color: DOC.taupe, margin: [0, 0, 0, 2] },
      { text: t.val, fontSize: 11, color: DOC.ink },
    ],
  }));
  const termsTable = {
    table: { widths: m.terms.map(() => '*'), body: [termCells] },
    layout: {
      fillColor: () => DOC.tableBg,
      hLineWidth: () => 0,
      vLineWidth: (i) => (i === 0 || i === m.terms.length ? 0 : 0.3),
      vLineColor: () => DOC.rule,
      paddingLeft: () => 8, paddingRight: () => 8, paddingTop: () => 7, paddingBottom: () => 7,
    },
    margin: [0, 8, 0, 0],
  };

  // Rejilla de producto
  const headerRow = [
    { text: 'FOTO · IMG', style: 'colh' },
    { text: 'ARTÍCULO · ITEM', style: 'colh' },
    ...SIZE_COLS.map((s) => ({ text: s, style: 'colh', alignment: 'center' })),
    { text: 'UDS · QTY', style: 'colh', alignment: 'center' },
    { text: 'PRECIO · PRICE', style: 'colh', alignment: 'right' },
    { text: 'IMPORTE · TOTAL', style: 'colh', alignment: 'right' },
  ];
  const body = [headerRow];
  m.rows.forEach((r) => {
    const itemStack = [
      { text: r.code, bold: true, fontSize: 9, color: DOC.ink },
      { text: r.name, fontSize: 8, color: DOC.grey },
      { text: r.color, fontSize: 8, color: DOC.grey },
    ];
    if (r.composition) itemStack.push({ text: r.composition, fontSize: 8, color: DOC.taupe });
    const photo = r.image && state.imgCache[r.image]
      ? { image: state.imgCache[r.image], width: 38, alignment: 'center' }
      : { text: '', fontSize: 8 };
    const sizeCells = SIZE_COLS.map((sz) => {
      const sku = skuOf(r.styleCode, r.color, sz);
      const q = sku ? (state.qty[sku] || 0) : 0;
      return { text: q ? String(q) : '', alignment: 'center', fontSize: 9, color: DOC.ink };
    });
    body.push([
      photo,
      { stack: itemStack },
      ...sizeCells,
      { text: String(r.total), alignment: 'center', fontSize: 9, bold: true, color: DOC.ink },
      { text: m.showPrices && r.wholesale != null ? fmtMoney(r.wholesale, m.currency) : '', alignment: 'right', fontSize: 9, color: DOC.ink },
      { text: m.showPrices && r.amount != null ? fmtMoney(r.amount, m.currency) : '', alignment: 'right', fontSize: 9, color: DOC.ink },
    ]);
  });
  body.push([
    { text: '' },
    { text: `${m.totalLines === 1 ? '1 línea · 1 line' : (m.totalLines === 1 ? '1 línea · 1 line' : `${m.totalLines} líneas · ${m.totalLines} lines`)}`, fontSize: 8, color: DOC.taupe },
    ...SIZE_COLS.map(() => ({ text: '' })),
    { text: String(m.totalUnits), alignment: 'center', fontSize: 9, bold: true, color: DOC.ink },
    { text: '', alignment: 'right' },
    { text: m.showPrices ? fmtMoney(m.totalAmount, m.currency) : '', alignment: 'right', fontSize: 9, bold: true, color: DOC.ink },
  ]);

  const SIZE_W = 16;
  const widths = [44, '*', ...SIZE_COLS.map(() => SIZE_W), 28, 38, 40];
  const sizeFirst = 2;
  const sizeLast = sizeFirst + SIZE_COLS.length - 1;
  const totalCol = sizeLast + 1;

  const gridTable = {
    table: { headerRows: 1, widths, body },
    layout: {
      hLineWidth: (i) => (i === 0 ? 0 : i === 1 ? 0.5 : 0.3),
      vLineWidth: () => 0,
      hLineColor: () => DOC.rule,
      paddingLeft: () => 3, paddingRight: () => 3, paddingTop: () => 5, paddingBottom: () => 5,
      fillColor: (row, node, col) => {
        if (row === 0) return null;
        if (col === totalCol) return DOC.goldWash;           // columna TOTAL
        if (col >= sizeFirst && col <= sizeLast) {            // rejilla de tallas
          const cell = body[row][col];
          return cell && cell.text ? '#ffffff' : DOC.creamSoft;
        }
        return null;
      },
    },
    margin: [0, 14, 0, 0],
  };

  return {
    info: { title: `${b.fullName || b.name} ${b.season} · ${company}` },
    pageSize: 'A4',
    pageMargins: [34, 34, 34, 40],
    footer: (cur, total) => ({
      margin: [34, 0], fontSize: 7, color: DOC.grey,
      columns: [
        { text: `${iss.name || 'SES Palma'} · ${m.doc.kindEs} ${m.doc.number}` },
        { text: `${cur} / ${total}`, alignment: 'right' },
      ],
    }),
    content: [...header, partiesTable, termsTable, gridTable,
      ...(m.showPrices ? [{ text: 'Precios wholesale sin IVA · Wholesale prices exclude VAT. El IVA se aplica en la factura final según el país y el régimen fiscal del comprador.', fontSize: 8, color: DOC.taupe, margin: [0, 8, 0, 0] }] : [])],
    styles: { colh: { fontSize: 7, color: DOC.taupe } },
    defaultStyle: { fontSize: 9, color: DOC.ink },
  };
}

async function downloadPdf() {
  const fname = `Pedido_${(state.buyer.company || 'SES').replace(/[^\w]+/g, '_')}_${state.config.brand.season}.pdf`;
  const doc = await buildPdfDoc();
  pdfMake.createPdf(doc).download(fname);
}

/* ---------- LINESHEET por cliente ----------
   Mismo diseño que linesheets/build_linesheet.py (A4 apaisado, 3 fichas por hoja, fondo lino),
   pero con el catálogo de portal_catalog y los precios de la empresa con sesión (portal_prices)
   y el PVP del país de su tienda (portal_rrp). Se genera en el navegador: no hay PDF publicado. */
const LS = { paper: '#EFEAE0', card: '#F4F1E8', ink: '#1C1A17', label: '#6b6457' };
const LS_FONT = 'https://cdn.jsdelivr.net/fontsource/fonts/';
const LS_STYLE = { Shirt: 'Shirt', LongSleeveShirt: 'Shirt', ShortSleeveShirt: 'Shirt', Overshirt: 'Over shirt', Polo: 'Polo',
  TShirt: 'T-shirt', Trousers: 'Trousers', ShortTrousers: 'Shorts', SwimShort: 'Swim shorts', Jacket: 'Jacket', Accessory: 'Accessory' };
const LS_FIBER = [['Algodón orgánico', 'Organic cotton'], ['Algodón', 'Cotton'], ['Lino', 'Linen'], ['Cáñamo', 'Hemp'],
  ['Supima', 'Supima cotton'], ['Toquilla', 'Toquilla straw'], ['Elastano', 'Elastane'],
  ['Poliéster reciclado', 'Recycled polyester'], ['Poliéster', 'Polyester']];
const lsFabric = (f) => LS_FIBER.reduce((acc, [es, en]) => acc.split(es).join(en), f || '');

function lsFonts() {
  if (!window.pdfMake) return;
  pdfMake.fonts = Object.assign({}, pdfMake.fonts, {
    JostLight: { normal: LS_FONT + 'jost@5.1.1/latin-300-normal.ttf', bold: LS_FONT + 'jost@5.1.1/latin-500-normal.ttf',
      italics: LS_FONT + 'jost@5.1.1/latin-300-italic.ttf', bolditalics: LS_FONT + 'jost@5.1.1/latin-500-normal.ttf' },
    WorkSans: { normal: LS_FONT + 'work-sans@5.1.1/latin-400-normal.ttf', bold: LS_FONT + 'work-sans@5.1.1/latin-600-normal.ttf',
      italics: LS_FONT + 'work-sans@5.1.1/latin-400-normal.ttf', bolditalics: LS_FONT + 'work-sans@5.1.1/latin-600-normal.ttf' },
  });
}

// Imagen remota recortada (cover) a un tamaño fijo, como dataURL. Cachea por url+tamaño.
function lsCrop(url, w, h) {
  const key = `${url}#${w}x${h}`;
  if (!url) return Promise.resolve(null);
  if (state.imgCache[key]) return Promise.resolve(state.imgCache[key]);
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      try {
        const s = Math.max(w / img.width, h / img.height);
        const cv = document.createElement('canvas');
        cv.width = w; cv.height = h;
        const cx = cv.getContext('2d');
        cx.drawImage(img, (w - img.width * s) / 2, (h - img.height * s) / 2, img.width * s, img.height * s);
        state.imgCache[key] = cv.toDataURL('image/jpeg', 0.86);
        resolve(state.imgCache[key]);
      } catch (_) { resolve(null); }
    };
    img.onerror = () => resolve(null);
    img.src = url;
  });
}

function lsTextOn(hex) {
  const h = String(hex || '#000').replace('#', '');
  const f = h.length === 3 ? h.split('').map((x) => x + x).join('') : h.padEnd(6, '0');
  const [r, g, b] = [0, 2, 4].map((i) => parseInt(f.substr(i, 2), 16) || 0);
  return (0.299 * r + 0.587 * g + 0.114 * b) > 150 ? LS.ink : '#ffffff';
}
function lsEur(n, cur) { return n == null ? '—' : fmtMoney(n, cur || 'EUR').replace(/\s(€|[A-Z]{3})$/, ' $1'); }

// Precio mayorista de la empresa para un estilo: { min, max, cur } o null.
function lsWholesale(st) {
  let min = Infinity, max = 0, cur = 'EUR', loc = null;
  st.colors.forEach((c) => c.sizes.forEach((sz) => {
    const p = skuPrice(sz.sku);
    if (!p) return;
    if (p.w < min) { min = p.w; cur = p.cur; loc = localPrice(p); }
    if (p.w > max) max = p.w;
  }));
  return isFinite(min) ? { min, max, cur, loc } : null;
}
// País del PVP: el de la tienda de entrega elegida; si no, el primero con PVP de la empresa.
function lsRrpCountry() {
  const cc = rrpCountries()[0];
  if (cc) return cc;
  const stores = (state.auth.company && state.auth.company.stores) || [];
  const s = stores.find((x) => x.country_code && state.auth.rrp.has(x.country_code));
  return s ? s.country_code : null;
}
function lsRrp(st, cc) {
  const m = cc && state.auth.rrp.get(cc);
  if (!m) return null;
  for (const c of st.colors) for (const sz of c.sizes) { const r = m.get(sz.sku); if (r) return r; }
  return null;
}

async function lsCard(st, cc, photos, pats, noPrices) {
  const lab = (txt) => ({ text: txt, color: LS.label, fontSize: 7.5 });
  const val = (txt, o) => Object.assign({ text: txt || '', fontSize: 7.5, bold: false }, o || {});
  const w = lsWholesale(st);
  // moneda local primero y entre paréntesis la de facturación: «265.50 AED (59.00 €)»
  const wMain = w ? (w.loc ? `${lsEur(w.loc.n, w.loc.cur)} (${lsEur(w.min, w.cur)})` : lsEur(w.min, w.cur)) : null;
  const wTxt = w ? (w.max > w.min + 0.004 ? `from ${wMain}` : wMain) : 'On request';
  const r = lsRrp(st, cc);
  const rTxt = r ? lsEur(r.amount, r.cur) : '—';
  const colors = st.colors.map((c) => {
    const pat = pats[`${st.code}:${c.name}`];
    if (pat) {
      return { table: { widths: ['*', 46], body: [[
        { text: c.name, fontSize: 6.5, margin: [4, 2, 2, 2] },
        { image: pat, width: 46, height: 13 },
      ]] }, layout: { hLineWidth: () => 0.4, vLineWidth: () => 0.4, hLineColor: () => '#d8d2c4', vLineColor: () => '#d8d2c4',
        paddingLeft: () => 0, paddingRight: () => 0, paddingTop: () => 0, paddingBottom: () => 0 }, margin: [0, 0, 0, 2] };
    }
    const hex = c.hex || '#cccccc';
    return { table: { widths: ['*'], body: [[{ text: c.name, fontSize: 6.5, color: lsTextOn(hex), fillColor: hex, margin: [5, 1.5, 2, 1.5] }]] },
      layout: 'noBorders', margin: [0, 0, 0, 2] };
  });
  const spec = {
    table: { widths: [52, '*'], body: [
      [lab('Name'), val(st.name, { bold: true })],
      [lab('Style'), val(LS_STYLE[st.product_type] || st.product_type || '')],
      [lab('Materials'), val(lsFabric(st.fabric))],
      ...(noPrices ? [] : [[lab('SRP / RRP'), val(rTxt, { bold: true })], [lab('Wholesale'), val(wTxt, { bold: true })]]),
      [lab('Colors'), { stack: colors }],
    ] },
    layout: { hLineWidth: (i) => (i < (noPrices ? 4 : 6) ? 0.6 : 0), vLineWidth: () => 0, hLineColor: () => LS.ink,
      paddingLeft: () => 7, paddingRight: () => 7, paddingTop: () => 3.5, paddingBottom: () => 3.5 },
  };
  const photo = photos[st.code]
    ? { image: photos[st.code], width: 204, height: 272, alignment: 'center', margin: [0, 7, 0, 5] }
    : { canvas: [{ type: 'rect', x: 0, y: 0, w: 204, h: 272, color: '#e9e3d4' }], alignment: 'center', margin: [0, 7, 0, 5] };
  return {
    table: { widths: ['*'], body: [[{ stack: [photo, spec], fillColor: LS.card }]] },
    layout: { hLineWidth: () => 0.6, vLineWidth: () => 0.6, hLineColor: () => LS.ink, vLineColor: () => LS.ink,
      paddingLeft: () => 0, paddingRight: () => 0, paddingTop: () => 0, paddingBottom: () => 0 },
  };
}

// noPrices: copia interna sin tarifa (solo producto).
async function buildLinesheetDoc(noPrices) {
  const col = state.config.collection || {};
  const co = state.auth.company || {};
  const company = co.legal_name || co.name || '';
  const cc = lsRrpCountry();
  const cat = state.catalog;
  const photos = {};
  const pats = {};
  await Promise.all(cat.map(async (st) => {
    const src = safeUrl(resolveImg(st.image)) || st.colors.map(colorImg).find(Boolean);
    photos[st.code] = await lsCrop(src, 612, 816);
    await Promise.all(st.colors.filter((c) => c.patternImage).map(async (c) => {
      pats[`${st.code}:${c.name}`] = await lsCrop(safeUrl(resolveImg(c.patternImage)), 184, 52);
    }));
  }));
  const cards = await Promise.all(cat.map((st) => lsCard(st, cc, photos, pats, noPrices)));
  const sheets = [];
  for (let i = 0; i < cards.length; i += 3) {
    const row = cards.slice(i, i + 3);
    while (row.length < 3) row.push({ text: '' });
    sheets.push({ columns: row.map((c) => ({ width: '*', stack: [c] })), columnGap: 14, pageBreak: 'before' });
  }
  const sub = col.subtitle || 'Spring / Summer 2027';
  const date = new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
  const anyLocal = [...state.auth.prices.values()].map(localPrice).find(Boolean);
  const lcNote = anyLocal ? anyLocal.cur : null;
  const rrpNote = cc ? `SRP / RRP ${B2B ? B2B.countryName(cc) : cc}, incl. VAT` : 'SRP / RRP incl. VAT';
  const cover = { stack: [
    { text: 'SES PALMA', font: 'JostLight', fontSize: 30, characterSpacing: 9, alignment: 'center', margin: [0, 150, 0, 6] },
    { text: sub.toUpperCase(), font: 'JostLight', fontSize: 8.5, characterSpacing: 3, alignment: 'center' },
    { text: col.title || '', font: 'JostLight', italics: true, fontSize: 14, color: '#9a7b52', alignment: 'center', margin: [0, 18, 0, 22] },
    { columns: [{ width: '*', text: '' }, { width: 'auto',
      table: { body: [[{ text: 'WHOLESALE LINESHEET', font: 'JostLight', bold: true, fontSize: 9, characterSpacing: 3.4, margin: [14, 5, 14, 5] }]] },
      layout: { hLineWidth: () => 1, vLineWidth: () => 1, hLineColor: () => LS.ink, vLineColor: () => LS.ink } }, { width: '*', text: '' }] },
    { text: !noPrices && company ? `Prepared for ${company} · ${date}` : date, fontSize: 9, alignment: 'center', margin: [0, 26, 0, 4] },
    { text: noPrices ? `${cat.length} styles` : `Wholesale prices ${lcNote ? `in ${lcNote} (EUR, invoiced)` : 'in EUR'}, ex-VAT · ${rrpNote} · ${cat.length} styles`, fontSize: 7.5, color: LS.label, characterSpacing: 0.6, alignment: 'center' },
  ] };
  return {
    info: { title: `SES Palma ${season()} Linesheet${company ? ' · ' + company : ''}` },
    pageSize: 'A4', pageOrientation: 'landscape', pageMargins: [34, 30, 34, 32],
    background: (page, size) => ({ canvas: [{ type: 'rect', x: 0, y: 0, w: size.width, h: size.height, color: LS.paper }] }),
    footer: (cur, total) => (cur === 1 ? null : { margin: [34, 8, 34, 0], fontSize: 6.5, color: LS.label, columns: [
      { text: noPrices ? `SES Palma — ${sub} · sespalma.com` : `SES Palma — ${sub} · sespalma.com · Prices for ${company || 'your account'}, subject to confirmation` },
      { text: `${cur - 1} / ${total - 1}`, alignment: 'right', width: 40 },
    ] }),
    content: [cover, ...sheets],
    defaultStyle: { font: 'WorkSans', fontSize: 8, color: LS.ink },
  };
}

let lsBusy = false;
async function downloadLinesheet(btn) {
  if (lsBusy || !window.pdfMake) return;
  lsBusy = true;
  if (btn) btn.disabled = true;
  showToast(t('linesheet_wip'), 'ok');
  try {
    // los precios llegan justo después de entrar: se esperan unos segundos si aún no están
    for (let i = 0; i < 40 && state.auth.session && !state.auth.pricesLoaded && !state.auth.priceError; i++) {
      await new Promise((r) => setTimeout(r, 200));
    }
    lsFonts();
    const doc = await buildLinesheetDoc();
    const co = state.auth.company || {};
    const who = String(co.name || co.legal_name || 'SES').replace(/[^\w]+/g, '_').replace(/^_|_$/g, '');
    await new Promise((resolve, reject) => {
      try { pdfMake.createPdf(doc).download(`SES_Linesheet_${season()}_${who}.pdf`, resolve); } catch (e) { reject(e); }
    });
  } catch (e) {
    console.warn('linesheet', e);
    showToast(t('linesheet_err'), 'err');
  } finally {
    lsBusy = false;
    if (btn) btn.disabled = false;
  }
}

/* ---------- HOJA DE PEDIDO EN EXCEL (ida y vuelta) ----------
   Descarga: Excel con guía, fotos, precios de la empresa y PVP de su país; solo las cantidades
   son editables (assets/ses-pedidos-excel.js). Subida: se leen SOLO las cantidades, se casan por
   estilo|color|talla con el catálogo, sustituyen al pedido y se guardan como borrador. */
const XLS_LIB = 'https://cdn.jsdelivr.net/npm/exceljs@4.4.0/dist/exceljs.min.js';
let xlsLibLoad = null;
function loadExcelLib() {
  if (window.ExcelJS) return Promise.resolve(window.ExcelJS);
  if (!xlsLibLoad) {
    xlsLibLoad = new Promise((resolve, reject) => {
      const sc = document.createElement('script');
      sc.src = XLS_LIB;
      sc.onload = () => (window.ExcelJS ? resolve(window.ExcelJS) : reject(new Error('exceljs')));
      sc.onerror = () => { xlsLibLoad = null; reject(new Error('exceljs')); };
      document.head.appendChild(sc);
    });
  }
  return xlsLibLoad;
}
// el Excel sale en el idioma elegido en el portal (es / en / fr / it)
const xlsLang = () => (LANGS.includes(state.lang) ? state.lang : 'en');
const xlsText = (key, lang) => (I18N[key] && (I18N[key][lang] || I18N[key].en)) || '';
const b64 = (dataUrl) => (dataUrl ? { base64: String(dataUrl).split(',')[1], ext: /^data:image\/png/.test(dataUrl) ? 'png' : 'jpeg' } : null);

// PNG con transparencia (el logo va sobre fondo lino): sin recortar ni pasar a JPEG.
function xlsPng(url) {
  if (!url) return Promise.resolve(null);
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      try {
        const cv = document.createElement('canvas');
        cv.width = img.naturalWidth; cv.height = img.naturalHeight;
        cv.getContext('2d').drawImage(img, 0, 0);
        resolve({ dataUrl: cv.toDataURL('image/png'), w: cv.width, h: cv.height });
      } catch (_) { resolve(null); }
    };
    img.onerror = () => resolve(null);
    img.src = url;
  });
}
async function xlsLogo() {
  const base = window.SES_ASSET_BASE;
  const word = base ? await xlsPng(base + 'ses-logo.png') : null;
  if (word) return Object.assign(b64(word.dataUrl), { w: word.w, h: word.h });
  // sin el logotipo, el laurel de la marca (ses-data.js)
  return state.logoDataUrl ? Object.assign(b64(state.logoDataUrl), { w: 870, h: 870 }) : null;
}
function xlsDate(iso, lang) {
  const d = iso ? new Date(String(iso).length === 10 ? iso + 'T12:00:00' : iso) : null;
  const loc = { es: 'es-ES', fr: 'fr-FR', it: 'it-IT' }[lang] || 'en-GB';
  return d && !isNaN(d) ? d.toLocaleDateString(loc, { day: 'numeric', month: 'long', year: 'numeric' }) : null;
}

async function buildOrderExcelModel() {
  const lang = xlsLang();
  const co = state.auth.company || {};
  const col = state.config.collection || {};
  const brand = state.config.brand || {};
  const ow = state.config.orderWindow || {};
  const ru = state.auth.rules;
  const cc = lsRrpCountry();
  const rrpMap = cc ? state.auth.rrp.get(cc) : null;
  const rrpAny = rrpMap && rrpMap.size ? rrpMap.values().next().value : null;
  const groups = FILTER_GROUPS.filter((g) => g.types);
  const famOf = (type) => groups.findIndex((g) => g.types.includes(type));
  const families = groups.map((g) => ({ label: xlsText('filter_' + g.key, lang), items: [] }));
  const other = { label: { es: 'Otros', fr: 'Autres', it: 'Altro' }[lang] || 'Other', items: [] };
  const typeLabel = (type) => xlsText('type_' + type, lang) || type || '';
  const jobs = [];
  let localCur = null;
  for (const st of state.catalog) {
    const fi = famOf(st.product_type);
    const fam = fi >= 0 ? families[fi] : other;
    for (const c of st.colors) {
      const sizes = {};
      const qty = {};
      c.sizes.forEach((sz) => {
        const p = skuPrice(sz.sku);
        const loc = localPrice(p);
        sizes[sz.size] = { price: p ? p.w : 0, local: loc ? loc.n : 0 };
        if (loc) localCur = localCur || loc.cur;
        if (state.qty[sz.sku] > 0) qty[sz.size] = state.qty[sz.sku];
      });
      const rr = rrpMap && c.sizes.map((sz) => rrpMap.get(sz.sku)).find(Boolean);
      const it = {
        key: `${st.code}|${c.name}`, styleCode: st.code, styleName: st.name, typeLabel: typeLabel(st.product_type),
        color: c.name, hex: c.hex || null, fabric: lang === 'es' ? (st.fabric || '') : lsFabric(st.fabric),
        rrp: rr ? rr.amount : null, sizes, qty, photo: null, pattern: null,
      };
      const src = colorImg(c) || safeUrl(resolveImg(st.image));
      jobs.push(lsCrop(src, 162, 216).then((d) => { it.photo = b64(d); }));
      if (c.patternImage) jobs.push(lsCrop(safeUrl(resolveImg(c.patternImage)), 52, 52).then((d) => { it.pattern = b64(d); }));
      fam.items.push(it);
    }
  }
  const logoJob = xlsLogo();
  await Promise.all(jobs);
  const priced = [...state.auth.prices.values()][0];
  return {
    lang, season: season(),
    company: { id: state.auth.companyId, name: co.legal_name || co.name || '' },
    collection: { title: col.title || '', subtitle: (col.subtitle_i18n && col.subtitle_i18n[lang]) || col.subtitle || brand.seasonLabel || '' },
    generatedAt: new Date(), dateLabel: xlsDate(new Date().toISOString(), lang),
    portalUrl: (location.host + location.pathname).replace(/\/$/, ''),
    uploadUrl: location.origin + location.pathname + '#subir-excel',
    contactEmail: (brand.issuer && brand.issuer.email) || 'contact@sespalma.com',
    website: (brand.issuer && brand.issuer.website) || 'sespalma.com',
    currency: (priced && priced.cur) || 'EUR',
    // moneda local solo si TODOS los precios la tienen (si no, una columna mixta engañaría)
    local: localCur && [...state.auth.prices.values()].every((x) => localPrice(x) && localPrice(x).cur === localCur) ? { currency: localCur } : null,
    rrp: rrpAny ? { currency: rrpAny.cur, vat: rrpAny.vat, countryName: B2B ? B2B.countryName(cc) : cc, decimals: rrpAny.cur === 'EUR' ? 2 : 0 } : null,
    deadline: xlsDate(ru && ru.submit_until ? ru.submit_until : ow.orderDeadline, lang),
    delivery: xlsDate(ow.deliveryStart, lang),
    logo: await logoJob,
    families: families.concat([other]).filter((f) => f.items.length),
  };
}

let xlsBusy = false;
async function downloadOrderExcel(btn) {
  if (xlsBusy || !window.SESOrderExcel) return;
  xlsBusy = true;
  if (btn) btn.disabled = true;
  showToast(t('xls_wip'), 'ok');
  try {
    for (let i = 0; i < 40 && state.auth.session && !state.auth.pricesLoaded && !state.auth.priceError; i++) {
      await new Promise((r) => setTimeout(r, 200));
    }
    const [ExcelJS, model] = await Promise.all([loadExcelLib(), buildOrderExcelModel()]);
    const wb = await window.SESOrderExcel.build(ExcelJS, model);
    const buf = await wb.xlsx.writeBuffer();
    const who = String(model.company.name || 'SES').replace(/[^\w]+/g, '_').replace(/^_|_$/g, '');
    const a = document.createElement('a');
    a.href = URL.createObjectURL(new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
    a.download = `SES_Palma_${season()}_Order_${who}.xlsx`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(a.href), 4000);
  } catch (e) {
    console.warn('excel', e);
    showToast(t('xls_err'), 'err');
  } finally {
    xlsBusy = false;
    if (btn) btn.disabled = false;
  }
}

// Panel «Subir hoja de pedido»: zona para arrastrar o elegir el archivo. También se abre desde el
// botón «Enviar pedido a SES Palma» del propio Excel (enlace a esta página con #subir-excel).
function openUploadPanel() {
  if (!checkPortalOrder(false)) return;
  if (ordersClosed()) { showToast(B2B.errorMessage(state.auth.rules && state.auth.rules.enabled ? 'deadline_passed' : 'season_closed'), 'err'); return; }
  const box = document.createElement('div');
  box.innerHTML = `<p class="b2b-dialog-text">${esc(t('xls_drop_text'))}</p>
    <label class="xls-drop" tabindex="0" autofocus>
      <input type="file" accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" hidden>
      <span class="xls-drop-icon" aria-hidden="true">↑</span>
      <span class="xls-drop-title">${esc(t('xls_drop_title'))}</span>
      <span class="xls-drop-hint">${esc(t('xls_drop_hint'))}</span>
    </label>
    <p class="xls-drop-foot">${esc(t('xls_drop_nofile'))} <button type="button" data-action="download">${esc(t('xls_download'))}</button></p>`;
  B2B.dialog({
    title: t('xls_upload_title'), body: box, root: APP_ROOT,
    actions: [{ id: 'cancel', label: t('cancel'), kind: 'ghost' }],
    onMount: (el, done) => {
      const zone = el.querySelector('.xls-drop');
      const inp = el.querySelector('input[type=file]');
      const take = (f) => {
        if (!f) return;
        if (!/\.xlsx$/i.test(f.name)) { showToast(t('xls_not_xlsx'), 'err'); return; }
        done(f);
      };
      inp.addEventListener('change', () => take(inp.files && inp.files[0]));
      zone.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); inp.click(); } });
      ['dragenter', 'dragover'].forEach((ev) => zone.addEventListener(ev, (e) => { e.preventDefault(); zone.classList.add('is-over'); }));
      ['dragleave', 'drop'].forEach((ev) => zone.addEventListener(ev, () => zone.classList.remove('is-over')));
      zone.addEventListener('drop', (e) => { e.preventDefault(); take(e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]); });
    },
  }).then((res) => {
    if (res && typeof res === 'object' && 'name' in res) uploadOrderExcel(res);
    else if (res === 'download') downloadOrderExcel(byId('btnXlsDown'));
  });
}

// Enlace del botón del Excel (#subir-excel): abre el panel en cuanto hay empresa que puede pedir.
let xlsDeepDone = false;
function maybeOpenUploadFromLink() {
  if (xlsDeepDone || location.hash !== '#subir-excel' || !F('excel') || !appBooted) return;
  const a = state.auth;
  if (!a.session || !a.company || !a.rules) return;
  xlsDeepDone = true;
  try { history.replaceState(null, '', location.pathname + location.search); } catch (_) { /* */ }
  if (!canOrder()) { showToast(t('co_cannot_order'), 'err'); return; }
  setTimeout(openUploadPanel, 0);
}

async function uploadOrderExcel(file) {
  if (xlsBusy || !window.SESOrderExcel) return;
  xlsBusy = true;
  showToast(t('xls_reading'), 'ok');
  try {
    const [ExcelJS, buf] = await Promise.all([loadExcelLib(), file.arrayBuffer()]);
    const res = await window.SESOrderExcel.parse(ExcelJS, buf);
    if (!res.ok) { showToast(t(res.error === 'version' ? 'xls_version' : 'xls_not_ses'), 'err'); return; }
    if (res.meta.season !== season()) { showToast(t('xls_season', { season: res.meta.season || '?' }), 'err'); return; }
    const a = state.auth;
    if (res.meta.company && res.meta.company !== a.companyId) {
      const to = (a.company && (a.company.legal_name || a.company.name)) || '';
      const ok = await B2B.confirmDialog({ title: t('xls_other_title'), text: t('xls_other_text', { from: res.meta.companyName || '?', to }),
        okLabel: t('xls_replace_ok'), cancelLabel: t('cancel'), root: APP_ROOT });
      if (!ok) return;
    }
    // estilo|color|talla → SKU con el catálogo actual
    const index = new Map();
    state.catalog.forEach((st) => st.colors.forEach((c) => c.sizes.forEach((sz) => index.set(`${st.code}|${c.name}|${sz.size}`, sz.sku))));
    const next = {};
    const ignored = res.bad.map((b) => t('xls_bad_cell', { ref: b.ref }));
    res.cells.forEach((c) => {
      const sku = index.get(`${c.key}|${c.size}`);
      if (!sku) { ignored.push(t('xls_gone', { label: `${c.key.replace('|', ' · ')} · ${c.size}` })); return; }
      next[sku] = (next[sku] || 0) + c.qty;
    });
    const skus = Object.keys(next);
    if (!skus.length) { showToast(t('xls_empty'), 'err', ignored.length ? { list: ignored } : undefined); return; }
    const units = skus.reduce((n, k) => n + next[k], 0);
    const lines = new Set(skus.map((k) => `${state.skuMeta[k].styleCode}|${state.skuMeta[k].color}`)).size;
    // aviso previo siempre: qué se carga, cuánto suma y qué se ignora
    const prevQty = state.qty;
    state.qty = next;
    const sum = orderAmount();
    state.qty = prevQty;
    const text = [t('xls_confirm_text', { lines, units, amount: dualAmount(sum) || '–' }),
      t(totals().units > 0 ? 'xls_confirm_replace' : 'xls_confirm_new'),
      ignored.length ? t('xls_confirm_ignored', { n: ignored.length }) : ''].filter(Boolean).join(' ');
    const ok = await B2B.confirmDialog({ title: t('xls_replace_title'), text, okLabel: t('xls_replace_ok'), cancelLabel: t('cancel'), root: APP_ROOT });
    if (!ok) return;
    state.qty = next;
    saveDraft();
    renderCatalog();
    updateSummary();
    updateActionButtons();
    const saved = await savePortalDraft();
    const msg = t(saved ? 'xls_loaded_saved' : 'xls_loaded', { lines, units });
    showToast(ignored.length ? `${msg} ${t('xls_ignored', { n: ignored.length })}` : msg, ignored.length ? 'err' : 'ok', ignored.length ? { list: ignored } : undefined);
    openReview();
  } catch (e) {
    console.warn('excel', e);
    showToast(t('xls_not_ses'), 'err');
  } finally {
    xlsBusy = false;
  }
}

/* ---------- enviar con sesión: RPC portal_submit (el precio lo pone el servidor) ---------- */
function portalLines() {
  return Object.keys(state.qty).filter((sku) => state.qty[sku] > 0).sort().map((sku) => {
    const m = state.skuMeta[sku] || {};
    return { sku, qty: state.qty[sku], color: m.color || '', size: m.size || '' };
  });
}

// Comprueba lo necesario antes de enviar o guardar. Devuelve true si se puede seguir.
function checkPortalOrder(forSubmit) {
  const a = state.auth;
  if (!a.company) { showToast(t('co_need_company'), 'err'); focusCompanyCard(); return false; }
  if (!a.company.can_order) { showToast(t('co_cannot_order'), 'err'); return false; }
  if (!forSubmit) return true;
  if (ordersClosed()) { showToast(B2B.errorMessage(a.rules && a.rules.enabled ? 'deadline_passed' : 'season_closed'), 'err'); return false; }
  if (termsOutdated()) { showToast(B2B.errorMessage('terms_outdated'), 'err', { link: { href: location.href, label: t('reload') } }); return false; }
  if (totals().units === 0) { showToast(t('t_addqty'), 'err'); return false; }
  if ((a.company.stores || []).length && a.storeIds.length !== 1) {
    showToast(t('co_need_store'), 'err');
    focusCompanyCard(true);
    return false;
  }
  if (!pricesOn()) { showToast(a.priceError ? t('prices_error') : t('prices_empty', { season: season() }), 'err'); return false; }
  const miss = orderAmount().missing;
  if (miss.length) { showToast(t('missing_prices'), 'err', { list: miss.map(skuLabel) }); return false; }
  return true;
}

function focusCompanyCard(stores) {
  const rev = byId('reviewModal');
  if (rev && !rev.hidden) closeReview();
  const card = byId('buyerCard');
  const btn = byId('buyerToggle');
  if (card && card.classList.contains('collapsed')) { card.classList.remove('collapsed'); if (btn) btn.setAttribute('aria-expanded', 'true'); }
  const target = stores ? qs('.co-stores') : (qs('#coCompany') || qs('.co-stores'));
  if (!target) return;
  if (stores) { target.classList.add('input-error'); state.auth.storeError = true; }
  target.scrollIntoView({ block: 'center', behavior: 'smooth' });
  const f = target.matches('select') ? target : target.querySelector('select, input');
  if (f) f.focus({ preventScroll: true });
}

// Clave de idempotencia: la misma mientras el contenido del pedido no cambie y hasta que salga bien.
function idemKeyFor(payloadSig) {
  let saved = null;
  try { saved = JSON.parse(B2B.ss.get(IDEM_KEY) || 'null'); } catch (_) { saved = null; }
  if (saved && saved.sig === payloadSig && saved.key) return saved.key;
  const key = B2B.uuid();
  B2B.ss.set(IDEM_KEY, JSON.stringify({ key, sig: payloadSig }));
  return key;
}

async function sendPortalOrder() {
  if (!checkPortalOrder(true)) return;
  if (state.terms && !state.termsAccepted) { openTermsGate(); return; }
  const a = state.auth;
  setSending(true);
  try {
    if (!state.termsHash && state.terms) state.termsHash = await computeTermsHash(state.terms);
    const base = {
      p_company: a.companyId,
      p_season: season(),
      p_lines: portalLines(),
      p_terms_version: (state.termsAccepted && state.termsAccepted.version) || (state.terms && state.terms.version) || '',
      p_terms_hash: (state.termsAccepted && state.termsAccepted.hash) || state.termsHash || '',
      p_request: a.draftRequestId || null,
      p_store_ids: a.storeIds.slice(0, 1),
      p_po: a.po || null,
      p_comment: a.comment || null,
    };
    // una clave por cesta exacta (la misma huella que calcula el servidor): reintento = misma clave
    const withKey = (args) => Object.assign({}, args, { p_idem_key: idemKeyFor(JSON.stringify(args)) });
    const r = await B2B.rpc('portal_submit', withKey(base));
    if (r.error) {
      if (r.code === 'not_editable' && base.p_request) {
        // el borrador ya se envió (otro dispositivo o pestaña): nunca se crea otro pedido sin que
        // el comprador lo decida. Se suelta el borrador; un segundo «Enviar» será un pedido nuevo.
        rememberDraftId(null); a.draftRequestId = null; B2B.ss.del(IDEM_KEY);
        showToast(t('draft_already_sent'), 'err', { link: { href: `${PORTAL_URL}#/pedidos`, label: t('see_in_portal') }, ms: 15000 });
        return;
      }
      if (r.code === 'session_expired') { showToast(B2B.errorMessage(r.code), 'err'); doLogin(); return; }
      if (r.code === 'idempotency_conflict') B2B.ss.del(IDEM_KEY);
      if (r.code === 'one_store_required') { showToast(B2B.errorMessage(r.code), 'err'); focusCompanyCard(true); return; }
      if (r.code === 'terms_outdated') {
        state.termsAccepted = null;
        showToast(B2B.errorMessage(r.code), 'err', { link: { href: location.href, label: t('reload') } });
        loadRules();
        return;
      }
      if (r.code === 'deadline_passed' || r.code === 'season_closed') loadRules();
      if (r.code === 'missing_price' && r.detail) { showToast(B2B.errorMessage(r.code), 'err', { list: [skuLabel(r.detail)] }); return; }
      showToast(B2B.errorMessage(r.code), 'err');
      return;
    }
    const res = r.data || {};
    B2B.ss.del(IDEM_KEY);
    rememberDraftId(null);
    // los emails los envía el servidor desde su cola (cambio de turno, confirmación)
    a.draftRequestId = null;
    closeReview();
    clearOrder();
    const link = res.id ? { href: `${PORTAL_URL}#/pedidos/${encodeURIComponent(res.id)}`, label: t('see_in_portal') } : null;
    showToast(res.replayed ? t('sent_replayed', { ref: res.ref || '' }) : t('sent_ok', { ref: res.ref || '' }), 'ok', { link, ms: 12000 });
  } finally {
    setSending(false);
    updateActionButtons();
  }
}

async function savePortalDraft() {
  if (!checkPortalOrder(false)) return false;
  const a = state.auth;
  const btns = qsa('[data-draft-save]');
  btns.forEach((b) => { b.disabled = true; b.setAttribute('aria-busy', 'true'); b.textContent = t('draft_saving'); });
  try {
    const args = {
      p_company: a.companyId, p_season: season(), p_lines: portalLines(),
      p_request: a.draftRequestId || null, p_store_ids: a.storeIds.slice(0, 1), p_po: a.po || null,
    };
    let r = await B2B.rpc('portal_save_draft', args);
    if (r.code === 'not_editable' || r.code === 'not_found') r = await B2B.rpc('portal_save_draft', Object.assign({}, args, { p_request: null }));
    if (r.error) { showToast(B2B.errorMessage(r.code), 'err'); if (r.code === 'session_expired') doLogin(); return false; }
    a.draftRequestId = r.data;
    rememberDraftId(r.data);
    showToast(t('draft_saved_server'), 'ok');
    return true;
  } finally {
    btns.forEach((b) => { b.disabled = false; b.removeAttribute('aria-busy'); b.textContent = t('draft_save'); });
  }
}

/* ---------- enviar ---------- */
// Solo con sesión: el pedido va por la RPC portal_submit (el envío anónimo antiguo ya no existe).
async function sendOrder() {
  if (!B2B) return;
  if (state.auth.session) { await sendPortalOrder(); return; }
  doLogin();
}

/* ---------- gate de condiciones (CGV + privacidad) ---------- */
// texto canónico íntegro (para hash y PDF) — independiente del idioma de la UI
function termsFullText(terms) {
  const f = terms.full || {};
  const head = `${f.title || ''}\n${f.subtitle || ''}\n`;
  const body = (f.clauses || []).map((c) => `${c.n}. ${c.title}\n${(c.paras || []).join('\n')}`).join('\n\n');
  return `${terms.version || ''}\n${head}\n${body}`;
}

async function computeTermsHash(terms) {
  try {
    const data = new TextEncoder().encode(termsFullText(terms));
    const buf = await crypto.subtle.digest('SHA-256', data);
    return Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, '0')).join('');
  } catch (_) { return null; }
}

function tg(key) {
  const e = state.terms && state.terms.ui && state.terms.ui[key];
  if (!e) return key;
  return e[state.lang] || e.es || key;
}

function openTermsGate() {
  if (!state.terms) return;
  renderTermsGate();
  const m = byId('termsModal');
  termsReturn = document.activeElement;
  m.hidden = false;
  lockScroll(true);
  document.addEventListener('keydown', escCloseTerms);
  const first = byId('tgTerms');
  if (first) first.focus({ preventScroll: true });
}
let termsReturn = null;

function escCloseTerms(e) { if (e.key === 'Escape') closeTermsGate(); }

function closeTermsGate() {
  const m = byId('termsModal');
  if (!m || m.hidden) return;
  m.hidden = true;
  lockScroll(false);
  document.removeEventListener('keydown', escCloseTerms);
  const back = termsReturn;
  termsReturn = null;
  if (back && document.contains(back) && back.offsetParent !== null) back.focus({ preventScroll: true });
}

function renderTermsGate() {
  const terms = state.terms;
  const lang = state.lang;
  const titleEl = byId('termsTitle');
  if (titleEl) titleEl.textContent = tg('gate_title');
  const sum = (terms.summary && (terms.summary[lang] || terms.summary.es)) || [];
  const priv = (terms.privacy && (terms.privacy[lang] || terms.privacy.es)) || null;
  const box = byId('termsBody');
  box.innerHTML = `
    <p class="tg-intro">${esc(tg('gate_intro'))}</p>
    <div class="tg-summary">
      <div class="tg-summary-title">${esc(tg('summary_title'))}</div>
      <ul>${sum.map((s) => `<li>${esc(s)}</li>`).join('')}</ul>
    </div>
    <div class="tg-doclinks">
      <button type="button" class="tg-link" id="tgDownload">${esc(tg('download_doc'))}</button>
    </div>
    <p class="tg-langnote">${esc(tg('lang_note'))}</p>
    <label class="tg-check">
      <input type="checkbox" id="tgTerms" />
      <span>${esc(tg('accept_terms'))}</span>
    </label>
    <label class="tg-check">
      <input type="checkbox" id="tgPrivacy" />
      <span>${esc(tg('accept_privacy'))}</span>
    </label>
    ${priv ? `<details class="tg-privacy"><summary>${esc(tg('read_privacy'))}</summary>
      <strong>${esc(priv.title)}</strong>
      ${(priv.paras || []).map((p) => `<p>${esc(p)}</p>`).join('')}
    </details>` : ''}`;

  const cancel = byId('tgCancel');
  const confirm = byId('tgConfirm');
  cancel.textContent = tg('cancel');
  confirm.textContent = tg('confirm');
  const cbT = byId('tgTerms');
  const cbP = byId('tgPrivacy');
  const sync = () => { confirm.disabled = !(cbT.checked && cbP.checked); };
  cbT.addEventListener('change', sync);
  cbP.addEventListener('change', sync);
  sync();
  byId('tgDownload').addEventListener('click', downloadTermsPdf);
}

function confirmTermsGate() {
  const cbT = byId('tgTerms');
  const cbP = byId('tgPrivacy');
  if (!cbT || !cbP || !cbT.checked || !cbP.checked) {
    showToast(tg('must_accept'), 'err');
    return;
  }
  const now = new Date().toISOString();
  state.termsAccepted = {
    at: now,
    version: state.terms.version || null,
    hash: state.termsHash || null,
    privacyAt: now,
  };
  closeTermsGate();
  sendOrder(); // ahora pasa el gate y procede al envío real
}

/* PDF de las condiciones (documento completo) para descargar */
function buildTermsPdfDoc() {
  const f = state.terms.full || {};
  const content = [
    { text: f.title || 'Condiciones Generales de Venta Wholesale', style: 'tTitle' },
    { text: f.subtitle || '', style: 'tSub', margin: [0, 2, 0, 12] },
  ];
  (f.clauses || []).forEach((c) => {
    content.push({ text: `${c.n}. ${c.title}`, style: 'tH', margin: [0, 8, 0, 3] });
    (c.paras || []).forEach((p) => content.push({ text: p, style: 'tP', margin: [0, 0, 0, 4] }));
  });
  return {
    info: { title: 'SES Palma · Condiciones de Venta Wholesale' },
    pageSize: 'A4', pageMargins: [48, 56, 48, 56],
    defaultStyle: { fontSize: 9, lineHeight: 1.3, color: '#1a1a1a' },
    styles: {
      tTitle: { fontSize: 15, bold: true },
      tSub: { fontSize: 9, color: '#919da9' },
      tNote: { fontSize: 8, italics: true, color: '#aa8a70' },
      tH: { fontSize: 10, bold: true },
      tP: { fontSize: 9 },
    },
    content,
  };
}

async function downloadTermsPdf() {
  try {
    const doc = buildTermsPdfDoc();
    pdfMake.createPdf(doc).download(`SES_Condiciones_Wholesale_${state.terms.version || 'SS27'}.pdf`);
  } catch (e) { console.error(e); }
}

/* ---------- borrador en la cuenta (RPC portal_save_draft) ---------- */
async function saveDraftToServer() {
  if (!B2B) return;
  if (state.auth.session) { await savePortalDraft(); return; }
  doLogin();
}

function setSending(on) {
  document.body.classList.toggle('is-sending', on);
  ['btnSend', 'btnSend2'].forEach((id) => {
    const el = byId(id);
    if (!el) return;
    el.disabled = on;
    el.setAttribute('aria-busy', on ? 'true' : 'false');
    el.textContent = on ? t('sending') : t('send');
    if (!on) el.removeAttribute('aria-busy');
  });
}

/* ---------- toast ---------- */
let toastTimer = null;
function showToast(msg, kind, opts) {
  if (B2B) { B2B.toast(msg, kind, Object.assign({ root: APP_ROOT }, opts || {})); return; }
  const t = byId('toast');
  t.textContent = msg;
  t.className = 'toast' + (kind ? ' ' + kind : '');
  t.hidden = false;
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => (t.hidden = true), kind === 'err' ? 8000 : 3800);
}

/* ---------- eventos ---------- */
function wireEvents() {
  byId('searchBox').addEventListener('input', (e) => {
    state.search = e.target.value;
    renderCatalog();
  });
  const bt = byId('buyerToggle');
  if (bt) bt.addEventListener('click', toggleBuyerCard);
  const ls = byId('langSwitch');
  if (ls) ls.querySelectorAll('button[data-lang]').forEach((b) =>
    b.addEventListener('click', () => setLang(b.dataset.lang)));
  byId('btnReset').addEventListener('click', resetOrder);
  const r2 = byId('btnReset2');
  if (r2) r2.addEventListener('click', resetOrder);
  const sRe = byId('summaryReopen');
  if (sRe) sRe.addEventListener('click', () => showSummaryBar(true));
  byId('btnReview').addEventListener('click', openReview);
  byId('btnCloseReview').addEventListener('click', closeReview);
  byId('btnSend').addEventListener('click', sendOrder);
  byId('btnSend2').addEventListener('click', sendOrder);
  byId('btnPdf').addEventListener('click', downloadPdf);
  byId('reviewModal').addEventListener('click', (e) => {
    if (e.target.id === 'reviewModal') closeReview();
  });
  // gate de condiciones
  const tgC = byId('tgConfirm');
  const tgX = byId('tgCancel');
  if (tgC) tgC.addEventListener('click', confirmTermsGate);
  if (tgX) tgX.addEventListener('click', closeTermsGate);
  const tgM = byId('termsModal');
  if (tgM) tgM.addEventListener('click', (e) => { if (e.target.id === 'termsModal') closeTermsGate(); });
  // borradores
  const dSave = byId('btnDraftSave');
  if (dSave) dSave.addEventListener('click', saveDraftToServer);
  const dSaveBar = byId('btnDraftBar');
  if (dSaveBar) dSaveBar.addEventListener('click', saveDraftToServer);
  // ficha de producto
  byId('psClose').addEventListener('click', closeProduct);
  byId('psDone').addEventListener('click', closeProduct);
  const clr = byId('psClear');
  if (clr) clr.addEventListener('click', clearColorSizes);
  byId('productSheet').addEventListener('click', (e) => {
    if (e.target.id === 'productSheet') closeProduct();
  });
}

boot();
